import React, { useState, useEffect } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { Progress } from 'rsuite'
import CreateMasterBasicTab from './create-master-basic'
import CreateMasterCardTab from './create-master-card'
import CreateMasterAchTab from './create-master-ach'
import CreateMasterCheckTab from './create-master-check'
import LoaderComponent from '../../CommonComponents/LoaderComponent'
import { Steps } from 'rsuite';
import { useHistory } from 'react-router-dom'
import Select from 'react-select'
import {
  createMasterFromChilds, uploadAchInstruction, getChildSuppliers, uploadCardAuthorizationFormFile, addCardAcceptanceEmails, addSupplierHistory, getMasterSuppliers, getRelatedSupplierDetailsById, checkEmployerIdNumberExists,
  assignMaster
} from '../../../redux/actions/vendor'
import { toast } from '../../CommonComponents/ToastComponent/toast'
import { findDuplicateEmails, checkIsPhoneNumberValid, checkIsEmailValid, getAbbreviatedState, checkAmexCardConditonsAdded, checkVisaCardConditonsAdded, checkMasterCardConditonsAdded, checkZip, convertAddress } from '../../../services/helper'
import { parsePhoneNumber } from 'awesome-phonenumber'


const CreateMasterModal = ({
  show,
  selectedKeys,
  onClose,
  isCreateNewLocationMaster,
  selectedChildSuppliers,
  isFromList = false,
  listSupplier = null,
  onUpdateListSupplier,
  isCreatingMasterFromList = false,
  generalInfoData,
  isCreatingMasters = false,
  isFromRelatedSupplier = false,
  contactsData = []
}) => {
  const dispatch = useDispatch()
  const store = useStore().getState()
  const history = useHistory()
  const {
    vendor: {
      suppliers, childSuppliersContacts,
      masterSupplierDetails,
    },
    auth: { user },
    app: {
      createSupplierTabs,
      createSupplierBasicColumns,
      createSupplierAchColumns,
      createSupplierCardColumns,
      createSupplierCheckColumns
    }
  } = store
  const { id } = user
  const multiSelectColumns = ['productSpecificOptions', 'emailRemitRequirements', 'phoneRemitRequirements', 'faxRemitRequirements', 'onlineRemitRequirements', 'posRemitRequirements']

  useEffect(() => {
    if (isFromRelatedSupplier) {
      return
    }
    // isFromList ?
    //   history.push('/lists/newmastersupplier')
    //   :
    if (!isFromList) {
      history.push('/suppliers/newmastersupplier')
    }
  }, [history])

  const defaultCardFeeInfo = {
    showHideFee: {
      showAmexMinFee: false,
      showAmexMaxFee: false,
      showAmexIncrementalFee: false,
      showVisaMinFee: false,
      showVisaMaxFee: false,
      showVisaIncrementalFee: false,
      showMasterMinFee: false,
      showMasterMaxFee: false,
      showMasterIncrementalFee: false,
      showDiscoverMinFee: false,
      showDiscoverMaxFee: false,
      showDiscoverIncrementalFee: false,
      showAmexSecondProcessingFee: false,
      showVisaSecondProcessingFee: false,
      showMasterSecondProcessingFee: false,
      showDiscoverSecondProcessingFee: false
    }
  }

  const genericConditionColumns = [
    { name: 'processingFeeType', value: '$' },
    { name: 'processingFeeValue', value: '' },
    { name: 'processingSecondFeeType', value: '$' },
    { name: 'processingSecondFeeValue', value: '' },
    { name: 'minFeeType', value: '$' },
    { name: 'minFeeValue', value: '' },
    { name: 'maxFeeType', value: '$' },
    { name: 'maxFeeValue', value: '' },
    { name: 'incrementalFeeType', value: '$' },
    { name: 'incrementalFeeValue', value: '' },
    { name: 'minPayment', value: '' },
    { name: 'maxPayment', value: '' },
    { name: 'incrementalPayment', value: '' },
    { name: 'showVariableFee', value: null },
    { name: 'showMinFee', value: false },
    { name: 'showMaxFee', value: false },
    { name: 'showIncrementalFee', value: false },
    { name: 'showAnotherProcessingFee', value: false }
  ]

  const cardConditionColumns = [
    { name: 'amexProcessingFeeType', value: '$' },
    { name: 'amexProcessingFeeValue', value: '' },
    { name: 'amexSecondProcessingFeeType', value: '$' },
    { name: 'amexSecondProcessingFeeValue', value: '' },
    { name: 'amexMinPaymentFeeType', value: '$' },
    { name: 'amexMinPaymentFeeValue', value: '' },
    { name: 'amexMaxPaymentFeeType', value: '$' },
    { name: 'amexMaxPaymentFeeValue', value: '' },
    { name: 'amexIncrementalFeeType', value: '$' },
    { name: 'amexIncrementalFeeValue', value: '' },
    { name: 'amexIncrementalPaymentAmount', value: '' },
    { name: 'americanExpressMinPaymnet', value: '' },
    { name: 'americanExpressMaxPayment', value: '' },
    { name: 'isAcceptAmexVariableFee', value: null },
    { name: 'visaProcessingFeeType', value: '$' },
    { name: 'visaProcessingFeeValue', value: '' },
    { name: 'visaSecondProcessingFeeType', value: '$' },
    { name: 'visaSecondProcessingFeeValue', value: '' },
    { name: 'visaMinPaymentFeeType', value: '$' },
    { name: 'visaMinPaymentFeeValue', value: '' },
    { name: 'visaMaxPaymentFeeType', value: '$' },
    { name: 'visaMaxPaymentFeeValue', value: '' },
    { name: 'visaIncrementalFeeType', value: '$' },
    { name: 'visaIncrementalFeeValue', value: '' },
    { name: 'visaIncrementalPaymentAmount', value: '' },
    { name: 'visaMinPayment', value: '' },
    { name: 'visaMaxPayment', value: '' },
    { name: 'isAcceptVisaVariableFee', value: null },
    { name: 'mastercardProcessingFeeType', value: '$' },
    { name: 'mastercardProcessingFeeValue', value: '' },
    { name: 'mastercardSecondProcessingFeeType', value: '$' },
    { name: 'mastercardSecondProcessingFeeValue', value: '' },
    { name: 'mastercardMinPaymentFeeType', value: '$' },
    { name: 'mastercardMinPaymentFeeValue', value: '' },
    { name: 'mastercardMaxPaymentFeeType', value: '$' },
    { name: 'mastercardMaxPaymentFeeValue', value: '' },
    { name: 'mastercardIncrementalFeeType', value: '$' },
    { name: 'mastercardIncrementalFeeValue', value: '' },
    { name: 'mastercardIncrementalPaymentAmount', value: '' },
    { name: 'mastercardMinPayment', value: '' },
    { name: 'mastercardMaxPayment', value: '' },
    { name: 'isAcceptMasterCardVariableFee', value: null }
  ]

  const [isLoadingInfo, setIsLoadingInfo] = useState(false)
  const [currentTab, setCurrentTab] = useState(createSupplierTabs[0].name)
  const [selectedSuppliers, setSelectedSuppliers] = useState([])
  const [basicInfo, setBasicInfo] = useState({})
  const [childBasicInfo, setChildBasicInfo] = useState({})
  const [cardInfo, setCardInfo] = useState({})
  const [childCardInfo, setChildCardInfo] = useState({})
  const [achInfo, setAchInfo] = useState({})
  const [childAchInfo, setChildAchInfo] = useState({})
  const [checkInfo, setCheckInfo] = useState({})
  const [childCheckInfo, setChildCheckInfo] = useState({})
  const [achInstructionFile, setAchInstructionFile] = useState(null)
  const [cardAuthorizationFormFile, setCardAuthorizationFormFile] = useState(null)
  const [addCardEmailValues, setAddCardEmailValues] = useState({})
  const [supplierPrimaryCardEmail, setSupplierPrimaryCardEmail] = useState('')
  const [addedEmailValues, setAddedEmailValues] = useState([])
  const [isPhoneValid, setIsPhoneValid] = useState('')
  const [isFaxValid, setIsFaxValid] = useState(true)
  const [isBasicPhoneValid, setIsBasicPhoneValid] = useState('')
  const [isBasicFaxValid, setIsBasicFaxValid] = useState(true)
  const [isNaicsValid, setIsNaicsValid] = useState(true)
  const [isSicValid, setIsSicValid] = useState(true)
  const [progress, setProgress] = useState(0)
  const [currentStep, setCurrentStep] = useState(0)
  const [cardEmailType, setcardEmailType] = useState('')
  const [isValidatingBasicPhone, setIsValidatingBasicPhone] = useState(false)
  const [isValidatingCardPhone, setIsValidatingCardPhone] = useState(false)
  const [isEmailValid, setIsEmailValid] = useState('')
  const [isValidatingCardEmail, setIsValidatingCardEmail] = useState(false)
  const [isBasicEmailValid, setIsBasicEmailValid] = useState('')
  const [isEmailRisky, setIsEmailRisky] = useState('')
  const [isValidatingBasicEmail, setIsValidatingBasicEmail] = useState(false)
  const [isAchEmailValid, setIsAchEmailValid] = useState('')
  const [isValidatingAchEmail, setIsValidatingAchEmail] = useState(false)
  const [basicPhoneCountryCode, setBasicPhoneCountryCode] = useState('')
  const [cardPhoneCountryCode, setCardPhoneCountryCode] = useState('')
  const [deliveryMethodsFeeValues, setDeliveryMethodsFeeValues] = useState({})
  const [cardFeeInfo, setCardFeeInfo] = useState(defaultCardFeeInfo)
  const [showAcceptancePerCard, setShowAcceptancePerCard] = useState(false)
  const [accPerCardText, setAccPerCardText] = useState('Acceptance Per Card');
  const [isPortalUrlValid, setIsPortalUrlValid] = useState(true)
  const [isThirdPartyPortalUrlValid, setIsThirdPartyPortalUrlValid] = useState(true)
  const [isIVRPhoneValid, setIsIVRPhoneValid] = useState('')
  const [isValidatingIVRPhone, setIsValidatingIVRPhone] = useState(false)
  const [ivrCountryCode, setIVRCountryCode] = useState('')
  const [supplierExistWithEIN, setSupplierExistWithEIN] = useState({})
  const [isUserCreateSupWithDupEIN, setIsUserCreateSupWithDupEIN] = useState(false)
  const [isCheckBlurEINInput, setIsCheckBlurEINInput] = useState(false)
  const [onClickNext, setOnClickNext] = useState(false)
  const [showEINExistModal, setShowEINExistModal] = useState(false)
  const [genericFeeValues, setGenericFeeValues] = useState({
    showMinFee: false,
    showMaxFee: false,
    showIncrementalFee: false,
    showAnotherProcessingFee: false,
    showCreditCards: null,
    processingFeeType: '$',
    processingFeeValue: '',
    processingSecondFeeType: '$',
    processingSecondFeeValue: '',
    minFeeType: '$',
    minFeeValue: '',
    maxFeeType: '$',
    maxFeeValue: '',
    incrementalFeeType: '$',
    incrementalFeeValue: '',
    minPayment: '',
    maxPayment: '',
    incrementalPayment: '',
    showVariableFee: null,
    showCardConditions: null
  })
  const [portalURLError, setPortalURLError] = useState(false)
  const [isAssigningToExistingMaster, setIsAssigningToExistingMaster] = useState(false)
  const [allContacts, setAllContacts] = useState([])

  useEffect(() => {
    if ((!isFromList && !isFromRelatedSupplier) && (!selectedKeys || selectedKeys.length === 0)) {
      return
    }
    if ((!isFromList && !isFromRelatedSupplier) && (!suppliers || suppliers.length === 0)) {
      return
    }
    if (isCreateNewLocationMaster) {
      setIsLoadingInfo(true)
      dispatch(
        getRelatedSupplierDetailsById(selectedKeys)
      ).then((res) => {
        setIsLoadingInfo(false)
        const supplierArr = [res]
        setSelectedSuppliers(supplierArr)
      }).catch((err) => {
        setIsLoadingInfo(false)
        console.log(err)
      })
      setAllContacts(masterSupplierDetails?.contacts || [])
    } else if ((isFromList || isFromRelatedSupplier) && listSupplier) {
      setSelectedSuppliers([listSupplier])
    } else if (isCreatingMasters) {
      var currentIndex = selectedChildSuppliers?.indexOf(selectedSuppliers);
      const nextIndex = (currentIndex + 1) % selectedChildSuppliers?.length;
      let selectedSupplier = selectedChildSuppliers?.find((sup) => sup?.id === selectedChildSuppliers?.[nextIndex]?.id)
      setSelectedSuppliers([selectedSupplier])
    } else {
      setSelectedSuppliers(selectedChildSuppliers?.filter(supplier => selectedKeys.includes(supplier.id))) //suppliers
    }
    if (isFromList && !isCreateNewLocationMaster) {
      setAllContacts(contactsData || [])
    }
  }, [selectedKeys, suppliers])

  // initial basic info
  useEffect(async () => {
    if (!createSupplierBasicColumns || createSupplierBasicColumns.length === 0) {
      return
    }
    if (!selectedSuppliers || selectedSuppliers.length === 0) {
      return
    }
    setIsLoadingInfo(true)
    let tmpBasicInfo = {}
    let tmpChildBasicInfo = {}
    var phoneNumber = ''
    let stateCode = ''
    const usArray = ['united states', 'usa', 'us']
    let supplierColumns = [...createSupplierBasicColumns]
    supplierColumns.push({ name: 'phoneExtension', label: 'Phone Extension' })
    supplierColumns.forEach(async (column) => {
      if (column.name === 'fax') {
        if (!selectedSuppliers?.[0]?.[column.name] || /^([+]?[\s0-9]{3,})?(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(selectedSuppliers?.[0]?.[column.name])) {
          setIsBasicFaxValid(true)
        } else {
          setIsBasicFaxValid(false)
        }
      }

      if ((isFromList || isFromRelatedSupplier) && column.name === 'abbreviatedState') {
        stateCode = getAbbreviatedState('', selectedSuppliers?.[0]?.state)
        selectedSuppliers[0]['abbreviatedState'] = stateCode
      }

      // if (column.name === 'phone') {
      //   const supplier = selectedSuppliers?.[0] || {}
      //   const tmpValue = isCreateNewLocationMaster ? supplier?.masterSupplierInfo?.baseInfo[column.name] || '' : supplier[column.name] || ''
      //   const phone = tmpValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpValue) && /^\d+$/.test(tmpValue) ? childSuppliersContacts?.find(data => data?.phone === parseInt(tmpValue))?.phone : (tmpValue || '')
      //   const phoneContactId = tmpValue && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(tmpValue) && /^\d+$/.test(tmpValue) ? childSuppliersContacts?.find(data => data?.phone === parseInt(tmpValue))?.id : null
      //   tmpBasicInfo = {
      //     ...tmpBasicInfo,
      //     [column.name]: {
      //       label: phone,
      //       value: phone
      //     },
      //     phoneContactId: {
      //       label: phoneContactId,
      //       value: phoneContactId
      //     }
      //   }
      // } else {
      tmpBasicInfo = {
        ...tmpBasicInfo,
        [column.name]: selectedSuppliers.map(supplier => (
          {
            label: column.name === 'employerIdNumber' ? '' : isCreateNewLocationMaster ? supplier?.masterSupplierInfo?.baseInfo[column.name] || '' : supplier[column.name] || '',
            value: column.name === 'employerIdNumber' ? '' : isCreateNewLocationMaster ? supplier?.masterSupplierInfo.baseInfo[column.name] || '' : supplier[column.name] || '',
          }
        ))[0]
      }
      // }

      tmpChildBasicInfo = {
        ...tmpChildBasicInfo,
        [column.name]: selectedSuppliers.map(supplier => (
          {
            label: isCreateNewLocationMaster ? supplier?.baseInfo?.[column.name] : supplier[column.name] || '',
            value: isCreateNewLocationMaster ? supplier?.baseInfo?.[column.name] : supplier[column.name] || '', //column.name === 'phone' ? phoneNumber : 
          }
        ))[0]
      }
    })

    let phoneFromContact = ''
    let tmpValue = ''
    const contacts = (isFromList && !isCreateNewLocationMaster) ? contactsData : masterSupplierDetails?.contacts
    if (isCreateNewLocationMaster) {
      tmpValue = selectedSuppliers?.[0]?.masterSupplierInfo?.baseInfo ? selectedSuppliers?.[0]?.masterSupplierInfo?.baseInfo['phone'] : ''
      if (tmpValue && tmpValue?.toLowerCase() === 'null') {
        tmpValue = ''
      }
      if (tmpValue) {
        phoneFromContact = masterSupplierDetails?.contacts?.filter((contact) => contact?.id.toString() === tmpValue)?.[0]?.phone
      }
      phoneNumber = !phoneFromContact ? '' : selectedSuppliers?.[0]?.masterSupplierInfo?.baseInfo?.['country'] && usArray.includes(selectedSuppliers?.[0]?.['country']?.toLowerCase()) && phoneFromContact.startsWith('1') ? phoneFromContact : ((selectedSuppliers?.[0]?.masterSupplierInfo?.baseInfo?.['country'] && !usArray.includes(selectedSuppliers?.[0]?.masterSupplierInfo?.baseInfo?.['country']?.toLowerCase()))) ? phoneFromContact : phoneFromContact.startsWith('1') ? phoneFromContact : '1 ' + phoneFromContact
    } else {
      tmpValue = selectedSuppliers?.[0] ? selectedSuppliers?.[0]?.['phone'] : ''
      if (tmpValue && tmpValue?.toLowerCase() === 'null') {
        tmpValue = ''
      }
      if (tmpValue) {
        phoneFromContact = contacts?.filter((contact) => contact?.id.toString() === tmpValue)?.[0]?.phone || tmpValue
      }
      phoneNumber = !phoneFromContact ? '' : selectedSuppliers?.[0]?.['country'] && usArray.includes(selectedSuppliers?.[0]?.['country']?.toLowerCase()) && phoneFromContact.startsWith('1') ? phoneFromContact : ((selectedSuppliers?.[0]?.['country'] && !usArray.includes(selectedSuppliers?.[0]?.['country']?.toLowerCase()))) ? phoneFromContact : phoneFromContact.startsWith('1') ? phoneFromContact : '1 ' + phoneFromContact
    }
    const phoneContactId = tmpValue && /^\d+$/.test(tmpValue) ? contacts?.filter((contact) => contact?.id.toString() === tmpValue)?.[0]?.id : null

    tmpBasicInfo.phoneContactId = {
      label: phoneContactId,
      value: phoneContactId
    }

    handleBasicInfoInitialData(tmpBasicInfo, tmpChildBasicInfo, phoneNumber)

    // eslint-disable-next-line
  }, [selectedSuppliers])

  const handleBasicInfoInitialData = async (tmpBasicInfo = {}, tmpChildBasicInfo = {}, phoneNumber) => {
    const contacts = (isFromList && !isCreateNewLocationMaster) ? contactsData : masterSupplierDetails?.contacts
    let tmpValue = ''
    let emailFromContact = ''

    if (isCreateNewLocationMaster) {
      tmpValue = selectedSuppliers?.[0]?.masterSupplierInfo?.baseInfo ? selectedSuppliers?.[0]?.masterSupplierInfo?.baseInfo['email'] : ''
    } else {
      tmpValue = selectedSuppliers?.[0] ? selectedSuppliers?.[0]?.['email'] : ''
    }
    emailFromContact = tmpValue ? contacts?.filter((contact) => contact?.id.toString() === tmpValue)?.[0]?.email : tmpValue
    const emailContactId = tmpValue && /^\d+$/.test(tmpValue) ? contacts?.filter((contact) => contact?.id.toString() === tmpValue)?.[0]?.id : null
    tmpBasicInfo.emailContactId = {
      label: emailContactId,
      value: emailContactId
    }

    tmpBasicInfo['email'] = { label: emailFromContact, value: emailFromContact }

    await handleBasicInfoPhoneNumberFocusOut(null, null, phoneNumber, true, tmpBasicInfo, tmpChildBasicInfo)
    // await handleBasicInfoEmailFocusOut(selectedSuppliers?.[0]?.['email'])
    await handleBasicInfoEmailFocusOut(emailFromContact)

  }

  // initial card info
  useEffect(() => {
    if (!createSupplierCardColumns || createSupplierCardColumns.length === 0) {
      return
    }

    if (!selectedSuppliers || selectedSuppliers.length === 0) {
      return
    }
    let tmpCardInfo = {}
    let tmpChildCardInfo = {}

    createSupplierCardColumns.forEach(cardColumn => {
      if (cardColumn.name === 'ccProcessingTime') {
        if (isCreateNewLocationMaster) {
          tmpCardInfo = {
            ...tmpCardInfo,
            [cardColumn.name]: selectedSuppliers.map(supplier => (
              {
                label: supplier?.masterSupplierInfo?.cardInfo?.[cardColumn.name] || cardColumn.defaultValue + ' Days',
                value: supplier?.masterSupplierInfo?.cardInfo?.[cardColumn.name] || cardColumn.defaultValue,
              }
            ))[0]
          }
        } else {
          tmpCardInfo = {
            ...tmpCardInfo,
            [cardColumn.name]: {
              label: cardColumn.defaultValue + ' Days',
              value: cardColumn.defaultValue
            }
          }
        }

        tmpChildCardInfo = {
          ...tmpChildCardInfo,
          [cardColumn.name]: selectedSuppliers.map(supplier => (
            {
              label: isCreateNewLocationMaster ? supplier?.cardInfo?.[cardColumn.name] : supplier?.cardAcceptance?.[cardColumn.name],
              value: isCreateNewLocationMaster ? supplier?.cardInfo?.[cardColumn.name] : supplier?.cardAcceptance?.[cardColumn.name],
            }
          ))[0]
        }
      } else if (cardColumn.name === 'cardDiscountType') {
        if (isCreateNewLocationMaster) {
          tmpCardInfo = {
            ...tmpCardInfo,
            [cardColumn.name]: selectedSuppliers.map(supplier => (
              {
                label: !supplier?.masterSupplierInfo?.cardInfo?.[cardColumn.name] ? '%' : supplier?.masterSupplierInfo?.cardInfo?.[cardColumn.name] === 'Percentage' ? '%' : '$',
                value: supplier?.masterSupplierInfo?.cardInfo?.[cardColumn.name] || 'Percentage'
              }
            ))[0]
          }
        } else {
          tmpCardInfo = {
            ...tmpCardInfo,
            [cardColumn.name]: {
              label: '%',
              value: cardColumn.defaultValue
            }
          }
        }

        tmpChildCardInfo = {
          ...tmpChildCardInfo,
          [cardColumn.name]: selectedSuppliers.map(supplier => (
            {
              label: isCreateNewLocationMaster ?
                !supplier?.cardInfo?.[cardColumn.name] ? '%' : supplier?.cardInfo?.[cardColumn.name] === 'Percentage' ? '%' : '$'
                :
                !supplier?.cardAcceptance?.[cardColumn.name] ? '%' : supplier?.cardAcceptance?.[cardColumn.name] === 'Percentage' ? '%' : '$',
              value: isCreateNewLocationMaster ? supplier?.cardInfo?.[cardColumn.name] || 'Percentage' : supplier?.cardAcceptance?.[cardColumn.name] || 'Percentage',
            }
          ))[0]
        }
      } else {
        if (isCreateNewLocationMaster) {
          tmpCardInfo = {
            ...tmpCardInfo,
            [cardColumn.name]: selectedSuppliers.map(supplier => {
              if (multiSelectColumns.includes(cardColumn.name)) {
                let selectOptions = []
                const selectOptionsArray = supplier?.masterSupplierInfo?.cardInfo?.[cardColumn.name] ? supplier?.masterSupplierInfo?.cardInfo?.[cardColumn.name].split(',') : [];
                selectOptionsArray.map((option) => {
                  option = option.replace(/^\s+|\s+$/g, "");
                  selectOptions.push({
                    label: (option[0].toUpperCase() + option.slice(1)).replaceAll('-', ' '),
                    value: option
                  })
                })
                return selectOptions
              } else {
                return {
                  label: (cardColumn.name === 'advancedAcceptanceEnabled' || cardColumn.name === 'cardAuthorizationFormFile') ? cardColumn.defaultValue : supplier?.masterSupplierInfo?.cardInfo?.[cardColumn.name] || cardColumn.defaultValue,
                  value: (cardColumn.name === 'advancedAcceptanceEnabled' || cardColumn.name === 'cardAuthorizationFormFile') ? cardColumn.defaultValue : supplier?.masterSupplierInfo?.cardInfo?.[cardColumn.name] || cardColumn.defaultValue,
                }
              }
            })[0]
          }
        } else {
          if (multiSelectColumns.includes(cardColumn.name)) {
            tmpCardInfo = {
              ...tmpCardInfo,
              [cardColumn.name]: cardColumn.defaultValue
            }
          } else {
            tmpCardInfo = {
              ...tmpCardInfo,
              [cardColumn.name]: {
                label: typeof cardColumn.defaultValue !== 'string' ? JSON?.stringify(cardColumn.defaultValue)[0].toUpperCase() + JSON?.stringify(cardColumn.defaultValue).substring(1) : cardColumn.defaultValue,
                value: cardColumn.defaultValue
              }
            }
          }
        }

        if (cardColumn.name === 'cardPaymentByPhoneValue' || cardColumn.name === 'cardPaymentIVRPhone') {
          const contacts = (isFromList && !isCreateNewLocationMaster) ? contactsData : masterSupplierDetails?.contacts
          setIsPhoneValid(true)
          var cardPhoneNumber = '';
          let tmpCardPaymentByPhone = ''
          let tmpValue = ''
          if (isCreateNewLocationMaster) {
            tmpValue = selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo ? selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo[cardColumn.name] : ''
            tmpCardPaymentByPhone = masterSupplierDetails?.contacts?.filter((contact) => contact?.id.toString() === tmpValue)?.[0]?.phone
            cardPhoneNumber = !tmpCardPaymentByPhone ? '' : tmpCardPaymentByPhone
          } else {
            tmpValue = selectedSuppliers?.[0]?.cardAcceptance ? selectedSuppliers?.[0]?.cardAcceptance?.[cardColumn.name] : ''
            tmpCardPaymentByPhone = contacts?.filter((contact) => contact?.id.toString() === tmpValue)?.[0]?.phone
            cardPhoneNumber = !tmpCardPaymentByPhone ? '' : tmpCardPaymentByPhone
          }
          tmpCardInfo = {
            ...tmpCardInfo,
            [cardColumn.name]: selectedSuppliers.map(supplier => (
              {
                label: cardPhoneNumber,
                value: cardPhoneNumber,
              }
            ))[0]
          }
          let tmpPhoneContactId = ''
          let tmpIVRPhoneContactId = ''


          if (cardColumn.name === 'cardPaymentByPhoneValue') {
            tmpPhoneContactId = tmpValue ? contacts?.find(data => data?.id === parseInt(tmpValue))?.id : null
            tmpCardInfo.phoneContactId = {
              label: tmpPhoneContactId,
              value: tmpPhoneContactId,
            }
          } else {
            tmpIVRPhoneContactId = tmpValue ? contacts?.find(data => data?.id === parseInt(tmpValue))?.id : null
            tmpCardInfo.ivrPhoneContactId = {
              label: tmpIVRPhoneContactId,
              value: tmpIVRPhoneContactId,
            }
          }
        } else {
          tmpChildCardInfo = {
            ...tmpChildCardInfo,
            [cardColumn.name]: selectedSuppliers.map(supplier => {
              if (multiSelectColumns.includes(cardColumn.name)) {
                let childSelectOptions = []
                const childSelectOptionsArray = isCreateNewLocationMaster ?
                  supplier?.cardInfo?.[cardColumn.name] ? supplier?.cardInfo?.[cardColumn.name].split(',') : []
                  :
                  supplier?.cardAcceptance?.[cardColumn.name] ? supplier?.cardAcceptance?.[cardColumn.name].split(',') : []

                childSelectOptionsArray.map((option) => {
                  option = option.replace(/^\s+|\s+$/g, "");
                  childSelectOptions.push({
                    label: (option[0].toUpperCase() + option.slice(1)).replaceAll('-', ' '),
                    value: option
                  })
                })
                return childSelectOptions
              } else {
                return {
                  label: isCreateNewLocationMaster ? supplier?.cardInfo?.[cardColumn.name] : supplier?.cardAcceptance?.[cardColumn.name],
                  value: isCreateNewLocationMaster ? supplier?.cardInfo?.[cardColumn.name] : supplier?.cardAcceptance?.[cardColumn.name],
                }
              }
            })[0]
          }
        }
      }
    })

    setCardFeeInfo({
      ...cardFeeInfo,
      'showHideFee': {
        ...cardFeeInfo?.showHideFee,
        showAmexMinFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.['amexMinPaymentFeeValue'],
        showAmexMaxFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.['amexMaxPaymentFeeValue'],
        showAmexIncrementalFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.['amexIncrementalFeeValue'],
        showVisaMinFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.['visaMinPaymentFeeValue'],
        showVisaMaxFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.['visaMaxPaymentFeeValue'],
        showVisaIncrementalFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.['visaIncrementalFeeValue'],
        showMasterMinFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.['mastercardMinPaymentFeeValue'],
        showMasterMaxFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.['mastercardMaxPaymentFeeValue'],
        showMasterIncrementalFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.['mastercardIncrementalFeeValue'],
        showDiscoverMinFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.['discoverMinPaymentFeeValue'],
        showDiscoverMaxFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.['discoverMaxPaymentFeeValue'],
        showDiscoverIncrementalFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.['discoverIncrementalFeeValue'],
        showAmexSecondProcessingFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.amexSecondProcessingFeeValue ? true : false,
        showVisaSecondProcessingFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.visaSecondProcessingFeeValue ? true : false,
        showMasterSecondProcessingFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.mastercardSecondProcessingFeeValue ? true : false,
        showDiscoverSecondProcessingFee: selectedSuppliers[0]?.masterSupplierInfo?.cardInfo?.discoverSecondProcessingFeeValue ? true : false,
      }
    })

    if (isCreateNewLocationMaster) {
      setShowAcceptancePerCard(selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard)
      setGenericFeeValues({
        ...genericFeeValues,
        'showCreditCards': (selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAmericanExpress === null && selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptMasterCard === null && selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptVisa === null) ? null : (selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAmericanExpress && selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptMasterCard && selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptVisa) ? true : false,
        'processingFeeType': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? '$' : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.amexProcessingFeeType || '$',
        'processingFeeValue': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.amexProcessingFeeValue,
        'processingSecondFeeType': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? '$' : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.amexSecondProcessingFeeType || '$',
        'processingSecondFeeValue': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.amexSecondProcessingFeeValue,
        'minFeeType': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? '$' : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.amexMinPaymentFeeType || '$',
        'minFeeValue': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.amexMinPaymentFeeValue,
        'maxFeeType': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? '$' : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.amexMaxPaymentFeeType || '$',
        'maxFeeValue': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.amexMaxPaymentFeeValue,
        'incrementalFeeType': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? '$' : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.amexIncrementalFeeType || '$',
        'incrementalFeeValue': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.amexIncrementalFeeValue,
        'minPayment': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.americanExpressMinPaymnet,
        'maxPayment': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.americanExpressMaxPayment,
        'incrementalPayment': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? '' : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.amexIncrementalPaymentAmount,
        'showMinFee': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? false : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.amexMinPaymentFeeValue ? true : false,
        'showMaxFee': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? false : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.amexMaxPaymentFeeValue ? true : false,
        'showIncrementalFee': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? false : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.amexIncrementalFeeValue ? true : false,
        'showAnotherProcessingFee': selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? false : selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.amexSecondProcessingFeeValue ? true : false,
        'showCardConditions': (selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAmexCardConditions === null && selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptVisaCardConditions === null && selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptMastercardCardConditions === null) ? null : (selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAmexCardConditions && selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptVisaCardConditions && selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptMastercardCardConditions) ? true : false
      })

      selectedSuppliers?.[0]?.masterSupplierInfo?.cardInfo?.isAcceptAcceptancePerCard ? setAccPerCardText('Generic Fee Structure') : setAccPerCardText('Acceptance Per Card')
    }

    setIsEmailValid(true)
    setCardInfo(tmpCardInfo)
    setChildCardInfo(tmpChildCardInfo)
  }, [selectedSuppliers])

  useEffect(() => {
    if (!createSupplierAchColumns || createSupplierAchColumns.length === 0) {
      return
    }

    if (!selectedSuppliers || selectedSuppliers.length === 0) {
      return
    }
    let tmpAchInfo = {}
    let tmpChildAchInfo = {}
    createSupplierAchColumns.forEach(achColumn => {
      if (achColumn.name === 'emailAch') {
        let emailAch = ''
        let emailFromContact = ''
        let tmpValue = ''

        const contacts = (isFromList && !isCreateNewLocationMaster) ? contactsData : masterSupplierDetails?.contacts
        if (isCreateNewLocationMaster) {
          tmpValue = selectedSuppliers?.[0]?.masterSupplierInfo?.paymentInfo ? selectedSuppliers?.[0]?.masterSupplierInfo?.paymentInfo['emailAch'] : ''
          if (tmpValue) {
            emailFromContact = masterSupplierDetails?.contacts?.filter((contact) => contact?.id.toString() === tmpValue)?.[0]?.email
          }
          emailAch = !emailFromContact ? '' : emailFromContact
        }
        const emailContactId = tmpValue && /^\d+$/.test(tmpValue) ? contacts?.filter((contact) => contact?.id.toString() === tmpValue)?.[0]?.id : null
        tmpAchInfo = {
          ...tmpAchInfo,
          [achColumn.name]: { label: emailAch, value: emailAch }
        }
        tmpAchInfo.emailContactId = {
          label: emailContactId,
          value: emailContactId
        }

        tmpChildAchInfo = {
          ...tmpChildAchInfo,
          [achColumn.name]: selectedSuppliers.map(supplier => (
            {
              label: isCreateNewLocationMaster ? supplier?.paymentInfo?.[achColumn.name] : supplier?.payment?.[achColumn.name],
              value: isCreateNewLocationMaster ? supplier?.paymentInfo?.[achColumn.name] : supplier?.payment?.[achColumn.name],
            }
          ))[0]
        }
        setIsAchEmailValid(true)
        return
      }

      if (isCreateNewLocationMaster) {
        tmpAchInfo = {
          ...tmpAchInfo,
          [achColumn.name]: selectedSuppliers.map(supplier => (
            {
              label: achColumn.name === 'achInstructions' ? achColumn.defaultValue : supplier?.masterSupplierInfo?.paymentInfo?.[achColumn.name] || achColumn.defaultValue,
              value: achColumn.name === 'achInstructions' ? achColumn.defaultValue : supplier?.masterSupplierInfo?.paymentInfo?.[achColumn.name] || achColumn.defaultValue,
            }
          ))[0]
        }
      } else {
        tmpAchInfo = {
          ...tmpAchInfo,
          [achColumn.name]: {
            label: typeof achColumn.defaultValue !== 'string' ? JSON?.stringify(achColumn.defaultValue)[0].toUpperCase() + JSON?.stringify(achColumn.defaultValue).substring(1) : achColumn.defaultValue,
            value: achColumn.defaultValue
          }
        }
      }

      tmpChildAchInfo = {
        ...tmpChildAchInfo,
        [achColumn.name]: selectedSuppliers.map(supplier => (
          {
            label: isCreateNewLocationMaster ? supplier?.paymentInfo?.[achColumn.name] : supplier?.payment?.[achColumn.name],
            value: isCreateNewLocationMaster ? supplier?.paymentInfo?.[achColumn.name] : supplier?.payment?.[achColumn.name],
          }
        ))[0]
      }
    })
    setAchInfo(tmpAchInfo)
    setChildAchInfo(tmpChildAchInfo)
    // eslint-disable-next-line
  }, [selectedSuppliers])

  // initial check info
  useEffect(() => {
    if (!createSupplierCheckColumns || createSupplierCheckColumns.length === 0) {
      return
    }

    if (!selectedSuppliers || selectedSuppliers.length === 0) {
      return
    }
    let tmpCheckInfo = {}
    let tmpChildCheckInfo = {}
    createSupplierCheckColumns.forEach(checkColumn => {
      if (checkColumn.name === 'cashDiscountType') {
        if (isCreateNewLocationMaster) {
          tmpCheckInfo = {
            ...tmpCheckInfo,
            [checkColumn.name]: selectedSuppliers.map(supplier => (
              {
                label: !supplier?.masterSupplierInfo?.paymentInfo?.[checkColumn.name] ? '%' : supplier?.masterSupplierInfo?.paymentInfo?.[checkColumn.name] === 'Percentage' ? '%' : '$',
                value: supplier?.masterSupplierInfo?.paymentInfo?.[checkColumn.name] || 'Percentage'
              }
            ))[0]
          }
        } else {
          tmpCheckInfo = {
            ...tmpCheckInfo,
            [checkColumn.name]: {
              label: '%',
              value: checkColumn.defaultValue
            }
          }
        }

        tmpChildCheckInfo = {
          ...tmpChildCheckInfo,
          [checkColumn.name]: selectedSuppliers.map(supplier => (
            {
              label: isCreateNewLocationMaster ?
                !supplier?.paymentInfo?.[checkColumn.name] ? '%' : supplier?.paymentInfo?.[checkColumn.name] === 'Percentage' ? '%' : '$'
                :
                !supplier?.payment?.[checkColumn.name] ? '%' : supplier?.payment?.[checkColumn.name] === 'Percentage' ? '%' : '$',
              value: isCreateNewLocationMaster ? supplier?.paymentInfo?.[checkColumn.name] || 'Percentage' : supplier?.payment?.[checkColumn.name] || 'Percentage',
            }
          ))[0]
        }
      } else {
        if (isCreateNewLocationMaster) {
          tmpCheckInfo = {
            ...tmpCheckInfo,
            [checkColumn.name]: selectedSuppliers.map(supplier => (
              {
                label: supplier?.masterSupplierInfo?.paymentInfo?.[checkColumn.name] || checkColumn.defaultValue,
                value: supplier?.masterSupplierInfo?.paymentInfo?.[checkColumn.name] || checkColumn.defaultValue,
              }
            ))[0]
          }
        } else {
          tmpCheckInfo = {
            ...tmpCheckInfo,
            [checkColumn.name]: {
              label: typeof checkColumn.defaultValue !== 'string' ? JSON?.stringify(checkColumn.defaultValue)[0].toUpperCase() + JSON?.stringify(checkColumn.defaultValue).substring(1) : checkColumn.defaultValue,
              value: checkColumn.defaultValue
            }
          }
        }

        tmpChildCheckInfo = {
          ...tmpChildCheckInfo,
          [checkColumn.name]: selectedSuppliers.map(supplier => (
            {
              label: isCreateNewLocationMaster ? supplier?.paymentInfo?.[checkColumn.name] : supplier?.payment?.[checkColumn.name],
              value: isCreateNewLocationMaster ? supplier?.paymentInfo?.[checkColumn.name] : supplier?.payment?.[checkColumn.name],
            }
          ))[0]
        }
      }
    })
    setCheckInfo(tmpCheckInfo)
    setChildCheckInfo(tmpChildCheckInfo)
    // eslint-disable-next-line
  }, [selectedSuppliers])

  const handleUpdateBasicInfo = (colName, item, isValid = false) => {
    let tmpValue = {
      label: item?.target?.value,
      value: item?.target?.value
    }
    if (colName === 'state' || colName === 'country') {
      if (/^[a-zA-Z\s]+$/.test(item?.target?.value)) {
        tmpValue.value = item?.target?.value
      } else {
        tmpValue.value = item?.target?.value.match(/^[a-zA-Z\s]+/gi) ? item?.target?.value.match(/^[a-zA-Z\s]+/gi)[0] : ''
      }
    } else if (colName === 'fax') {
      tmpValue.value = item?.target?.value
      if (!item?.target?.value || /^([+]?[\s0-9]{3,})?(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(item?.target?.value)) {
        setIsBasicFaxValid(true)
      } else {
        setIsBasicFaxValid(false)
      }
    } else if (colName === 'zip') {
      if (/^\d{5}(-\d{4})?$/.test(item?.target?.value)) {
        tmpValue.value = item?.target?.value
      } else {
        tmpValue.value = item?.target?.value.match(/^\d{1,5}(-\d{0,4})?/gi) ? item?.target?.value.match(/^\d{1,5}(-\d{0,4})?/gi)[0] : ''
      }
    } else if (colName === 'naics') {
      tmpValue.value = item?.target?.value
      if (item?.target?.value === '' || item?.target?.value === undefined || /^(\d{5}|\d{6})?$/i.test(item?.target?.value)) {
        setIsNaicsValid(true)
      } else {
        setIsNaicsValid(false)
      }
    } else if (colName === 'sic') {
      tmpValue.value = item?.target?.value
      if (item?.target?.value === '' || item?.target?.value === undefined || /^\d{4}?$/i.test(item?.target?.value)) {
        setIsSicValid(true)
      } else {
        setIsSicValid(false)
      }
    } else if (colName === 'phoneExtension') {
      if (/^\d{20}$/.test(item?.target?.value)) {
        tmpValue.value = item?.target?.value
      } else {
        tmpValue.value = item?.target?.value.match(/^\d{1,20}/gi) ? item?.target?.value.match(/^\d{1,20}/gi)[0] : ''
      }
    } else if (colName === 'employerIdNumber') {
      if (item?.target?.value.length === 3 && item?.target?.value.includes('-')) {
        item.target.value = item?.target?.value.replaceAll('-', '')
      } else if (item?.target?.value.length === 2 || item?.target?.value.length === 3) {
        if (item?.target?.value.length === 3) {
          item.target.value = item?.target?.value.substring(0, 2) + '-' + item?.target?.value.substring(2)
        } else {
          item.target.value += '-'
        }
      }
      if (/^\d{2}(-\d{7})?$/.test(item?.target?.value)) {
        tmpValue.value = item?.target?.value
      } else {
        tmpValue.value = item?.target?.value.match(/^\d{1,2}(-\d{0,7})?/gi) ? item?.target?.value.match(/^\d{1,2}(-\d{0,7})?/gi)[0] : ''
      }
    } else if (colName === 'abbreviatedState') {
      let regex = /^[a-zA-Z\s]{2}$/
      let regex1 = /^[a-zA-Z\s]{1,2}/gi
      if (basicInfo?.country.value && (basicInfo?.country.value.trim().toLowerCase() === 'australia' || basicInfo?.country.value.trim().toLowerCase() === 'aus')) {
        regex = /^[a-zA-Z\s]{3}$/
        regex1 = /^[a-zA-Z\s]{1,3}/gi
      }
      if (regex.test(item?.target?.value)) {
        tmpValue.value = tmpValue.label = item?.target?.value.trim().toUpperCase()
      } else {
        tmpValue.value = tmpValue.label = item?.target?.value.trim().match(regex1) ? item?.target?.value.trim().match(regex1)[0].toUpperCase() : ''
      }
    } else if (colName === 'parseAddress') {
      setBasicInfo({
        ...basicInfo,
        'address1': {
          label: item?.add1 ? item?.add1 : '',
          value: item?.add1 ? item?.add1 : ''
        },
        'address2': {
          label: item?.add2 ? item?.add2 : '',
          value: item?.add2 ? item?.add2 : ''
        },
        'city': {
          label: item?.city ? item?.city?.value : '',
          value: item?.city ? item?.city?.value : ''
        },
        'state': {
          label: item?.state ? item?.state?.value : '',
          value: item?.state ? item?.state?.value : ''
        },
        'abbreviatedState': {
          label: item?.state ? item?.state?.value : '',
          value: item?.state ? item?.state?.value : ''
        },
        'country': {
          label: item?.country ? item?.country?.value : '',
          value: item?.country ? item?.country?.value : ''
        },
        'zip': {
          label: item?.zip ? item?.zip?.value : '',
          value: item?.zip ? item?.zip?.value : ''
        }
      })
      return
    } else if (colName === 'phone') {
      if (tmpValue?.value === '' || !tmpValue?.value) {
        setIsBasicPhoneValid(true)
      } else {
        isValid ? setIsBasicPhoneValid(true) : setIsBasicPhoneValid(false)
      }
    } else if (colName === 'email') {
      if (tmpValue?.value === '' || !tmpValue?.value) {
        setIsBasicEmailValid(true)
      } else {
        isValid ? setIsBasicEmailValid(true) : setIsBasicEmailValid(false)
      }
    }


    if (item?.target?.emailContactId || item?.target?.hasOwnProperty('emailContactId')) {
      setBasicInfo({
        ...basicInfo,
        [colName]: tmpValue,
        emailContactId: {
          label: item?.target?.emailContactId,
          value: item?.target?.emailContactId
        }
      })
    } else if (item?.target?.phoneContactId || item?.target?.hasOwnProperty('phoneContactId')) {
      setBasicInfo({
        ...basicInfo,
        [colName]: tmpValue,
        phoneContactId: {
          label: item?.target?.phoneContactId,
          value: item?.target?.phoneContactId
        }
      })
    } else {
      setBasicInfo({ ...basicInfo, [colName]: tmpValue })
    }
  }

  const handleUpdateCardInfo = (colName, item, type = null) => {
    var discountValue = ''
    if (colName === 'acceptCardPaymentType') {
      if (item.length === 0) {
        setCardInfo({
          ...cardInfo,
          acceptCardPaymentType: [],
          isAcceptCardPaymentByEmail: { label: 'false', value: false },
          isAcceptCardPaymentByFax: { label: 'false', value: false },
          isAcceptCardPaymentByPhone: { label: 'false', value: false },
          isAcceptCardPaymentByOnlinePortal: { label: 'false', value: false },
        })
        return
      } else {
        setCardInfo({
          ...cardInfo,
          acceptCardPaymentType: item,
          isAcceptCardPaymentByEmail: { label: 'false', value: item.findIndex(cardPayment => cardPayment.value === 'email') !== -1 },
          isAcceptCardPaymentByFax: { label: 'false', value: item.findIndex(cardPayment => cardPayment.value === 'fax') !== -1 },
          isAcceptCardPaymentByPhone: { label: 'false', value: item.findIndex(cardPayment => cardPayment.value === 'phone') !== -1 },
          isAcceptCardPaymentByOnlinePortal: { label: 'false', value: item.findIndex(cardPayment => cardPayment.value === 'portal') !== -1 },
        })
        return
      }
    }

    if (type === 'currency' || type === 'percent') {
      var temp = "";
      temp = parseInt(item?.value.replace(/\D/g, ''));
      item.value = temp ? ((temp) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
      if (type === 'currency') {
        if (/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/.test(item?.value)) {
          setCardInfo({
            ...cardInfo,
            [colName]: item
          })
        } else {
          setCardInfo({
            ...cardInfo,
            [colName]: {
              ...item,
              value: item?.value?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? item.value.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
            }
          })
        }
        return
      }
      if (type === 'percent') {
        if (/^\d{0,2}(\.\d{0,2})?$/.test(item?.value)) {
          setCardInfo({
            ...cardInfo,
            [colName]: item
          })
        } else {
          setCardInfo({
            ...cardInfo,
            [colName]: {
              ...item,
              value: item?.value?.match(/^\d{0,2}(\.\d{0,2})?/gi) ? item.value.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
            }
          })
        }
        return
      }
    }

    if (type === 'discounttype') {
      discountValue = item?.value === 'Percentage' ? cardInfo?.cardDiscountValue?.value && cardInfo?.cardDiscountValue?.value?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ?
        parseInt(cardInfo?.cardDiscountValue?.value.replace(',', '').match(/^\d{0,2}(\.\d{0,2})?/gi)[0]).toFixed(2)
        : ''
        : cardInfo?.cardDiscountValue?.value

      setCardInfo({
        ...cardInfo,
        cardDiscountValue: {
          value: discountValue
        },
        [colName]: item
      })
      return
    }

    if (type === 'fax') {
      if (item?.value === '' || /^([+]?[\s0-9]{3,})?(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(item?.value)) {
        if (type === 'phone') {
          // setIsPhoneValid(true)
        } else {
          setIsFaxValid(true)
        }
      } else {
        if (type === 'phone') {
          // setIsPhoneValid(false)
        } else {
          setIsFaxValid(false)
        }
      }
    }

    if (colName === 'emailType') {
      setcardEmailType(item?.value)
      return
    }

    if (type === 'phone') {
      if (item?.value === '' || !item?.value) {
        colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(true) : setIsIVRPhoneValid(true)
      } else {
        colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(false) : setIsIVRPhoneValid(false)
      }

      // var phoneValue = item?.value?.replace(/^\s*(?:\+?(\d{1,4}))\s?/, '')?.replace(/[^\w\s]|[\s]/gi, '')
      // var countrycode = country?.dialCode ? country?.dialCode + ' ' : ''
      // if (phoneValue !== '') {
      //   phoneValue = countrycode + phoneValue
      //   if (phoneValue === '' || !phoneValue) {
      //     colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(true) : setIsIVRPhoneValid(true)
      //   } else {
      //     colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(false) : setIsIVRPhoneValid(false)
      //   }
      //   // colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid('') : setIsIVRPhoneValid('')
      // } else {
      //   phoneValue = country.dialCode
      //   colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(true) : setIsIVRPhoneValid(true)
      // }
      // if (event.target === null) {
      //   handleCardPhoneNumberFocusOut(event, country, item?.value, colName)
      // }
      // colName === 'cardPaymentByPhoneValue' ? setCardPhoneCountryCode(country.dialCode) : setIVRCountryCode(country.dialCode)
      // item.value = phoneValue
    }

    if (type === 'extension') {
      if (/^\d{20}$/.test(item.value)) {
        item.value = item.value
      } else {
        item.value = item.value.match(/^\d{1,20}/gi) ? item.value.match(/^\d{1,20}/gi)[0] : ''
      }
    }

    if (type === 'url') {
      if (item?.value === '' || /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/i.test(item?.value)) {
        if (colName === 'thirdPartyPortalUrl') {
          setIsThirdPartyPortalUrlValid(true)
        } else {
          setIsPortalUrlValid(true)
        }
      } else {
        if (colName === 'thirdPartyPortalUrl') {
          setIsThirdPartyPortalUrlValid(false)
        } else {
          setIsPortalUrlValid(false)
        }
      }
    }

    if (item?.phoneContactId || item?.hasOwnProperty('phoneContactId')) {
      setCardInfo({
        ...cardInfo,
        [colName]: item,
        phoneContactId: {
          label: item?.phoneContactId,
          value: item?.phoneContactId
        }
      })
    } else if (item?.ivrPhoneContactId || item?.hasOwnProperty('ivrPhoneContactId')) {
      setCardInfo({
        ...cardInfo,
        [colName]: item,
        ivrPhoneContactId: {
          label: item?.ivrPhoneContactId,
          value: item?.ivrPhoneContactId
        }
      })
    } else {
      setCardInfo({
        ...cardInfo,
        [colName]: item
      })
    }
  }

  const handleUpdateAchInfo = (colName, item) => {
    if (colName === 'bankAccountNumber') {
      if (/^\d{0,17}$/.test(item?.value)) {
        setAchInfo({
          ...achInfo,
          [colName]: item,
        })
      } else {
        setAchInfo({
          ...achInfo,
          [colName]: {
            ...item,
            value: item?.value?.match(/^\d{0,17}/gi) ? item.value.match(/^\d{0,17}/gi)[0] : ''
          }
        })
      }
      return
    }
    if (colName === 'bankRoutingNumber') {
      if (/^\d{0,9}$/.test(item?.value)) {
        setAchInfo({
          ...achInfo,
          [colName]: item,
        })
      } else {
        setAchInfo({
          ...achInfo,
          [colName]: {
            ...item,
            value: item?.value?.match(/^\d{0,9}/gi) ? item.value.match(/^\d{0,9}/gi)[0] : ''
          }
        })
      }
      return
    }

    if (colName === 'emailAch') {
      if (!item?.value) {
        setIsAchEmailValid(true)
      } else {
        setIsAchEmailValid(false)
      }
    }

    if (colName === 'achPortalURL') {
      if (item?.value === '' || /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/i.test(item?.value)) {
        setPortalURLError(false)
      } else {
        setPortalURLError(true)
      }
    }

    if (colName === 'isAchThroughPortal') {
      if (!item?.value) {
        setPortalURLError(false)
      }
      setAchInfo({
        ...achInfo,
        [colName]: item,
        achPortalURL: item?.value !== true ? '' : achInfo?.achPortalURL || { label: '', value: '' },
        bankName: item?.value !== true ? achInfo?.bankName : { label: '', value: '' },
        bankRoutingNumber: item?.value !== true ? achInfo?.bankRoutingNumber : { label: '', value: '' },
        bankAccountNumber: item?.value !== true ? achInfo?.bankAccountNumber : { label: '', value: '' }
      })
      return
    }

    if (item?.emailContactId || item?.hasOwnProperty('emailContactId')) {
      setAchInfo({
        ...achInfo,
        [colName]: item,
        emailContactId: {
          label: item?.emailContactId,
          value: item?.emailContactId
        }
      })
    } else {
      setAchInfo({
        ...achInfo,
        [colName]: item
      })
    }
  }

  const handleUpdateCheckInfo = (colName, item, type = null) => {
    var discountValue = '';
    if (colName === 'isAcceptPaymentAddressFromCompanyAddress') {
      const tmpCheckInfo = { ...checkInfo }
      tmpCheckInfo['isAcceptPaymentAddressFromCompanyAddress'] = item
      tmpCheckInfo.checkAddress1 = basicInfo.address1
      tmpCheckInfo.checkAddress2 = basicInfo.address2
      tmpCheckInfo.checkCity = basicInfo.city
      tmpCheckInfo.checkState = basicInfo.state
      tmpCheckInfo.checkZip = basicInfo.zip
      tmpCheckInfo.checkCountry = basicInfo.country
      setCheckInfo(tmpCheckInfo)
      return
    }

    if (type === 'discounttype') {
      discountValue = item?.value === 'Percentage' ? checkInfo?.cashDiscountValue?.value && checkInfo?.cashDiscountValue?.value?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ?
        parseInt(checkInfo?.cashDiscountValue?.value.replace(',', '').match(/^\d{0,2}(\.\d{0,2})?/gi)[0]).toFixed(2)
        : ''
        : checkInfo?.cashDiscountValue?.value

      setCheckInfo({
        ...checkInfo,
        cashDiscountValue: {
          value: discountValue
        },
        [colName]: item
      })
      return
    }
    if (type === 'currency' || type === 'percent') {
      var temp = "";
      temp = parseInt(item?.value.replace(/\D/g, ''));
      item.value = temp ? ((temp) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
      if (type === 'currency') {
        if (/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/.test(item?.value)) {
          setCheckInfo({
            ...checkInfo,
            [colName]: item
          })
        } else {
          setCheckInfo({
            ...checkInfo,
            [colName]: {
              ...item,
              value: item?.value?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? item.value.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
            }
          })
        }
        return
      }
      if (type === 'percent') {
        if (/^\d{0,2}(\.\d{0,2})?$/.test(item?.value)) {
          setCheckInfo({
            ...checkInfo,
            [colName]: item
          })
        } else {
          setCheckInfo({
            ...checkInfo,
            [colName]: {
              ...item,
              value: item?.value?.match(/^\d{0,2}(\.\d{0,2})?/gi) ? item.value.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
            }
          })
        }
        return
      }
    }

    if (colName === 'parseAddress') {
      setCheckInfo({
        ...checkInfo,
        'checkAddress1': {
          label: item?.add1 ? item?.add1 : '',
          value: item?.add1 ? item?.add1 : ''
        },
        'checkAddress2': {
          label: item?.add2 ? item?.add2 : '',
          value: item?.add2 ? item?.add2 : ''
        },
        'checkCity': {
          label: item?.city ? item?.city?.value : '',
          value: item?.city ? item?.city?.value : ''
        },
        'checkState': {
          label: item?.state ? item?.state?.value : '',
          value: item?.state ? item?.state?.value : ''
        },
        'checkCountry': {
          label: item?.country ? item?.country?.value : '',
          value: item?.country ? item?.country?.value : ''
        },
        'checkZip': {
          label: item?.zip ? item?.zip?.value : '',
          value: item?.zip ? item?.zip?.value : ''
        }
      })
      return
    }

    setCheckInfo({
      ...checkInfo,
      [colName]: item
    })
  }

  const handleClose = () => {
    setCurrentTab('basic')
    onClose()
  }

  const handleCreateMaster = () => {
    const basicData = {}
    const cardData = {}
    const checkData = {}
    const achData = {}

    if (basicPhoneCountryCode === basicInfo?.phone?.value) {
      basicInfo['phone']['value'] = ''
    }
    if (cardPhoneCountryCode === cardInfo?.cardPaymentByPhoneValue?.value) {
      cardInfo['cardPaymentByPhoneValue']['value'] = ''
    }
    if (ivrCountryCode === cardInfo?.cardPaymentIVRPhone?.value) {
      cardInfo['cardPaymentIVRPhone']['value'] = ''
    }

    Object.keys(basicInfo).forEach(key => {
      basicData[key] = basicInfo[key].value
    })

    Object.keys(cardInfo).forEach(key => {
      if (multiSelectColumns.includes(key)) {
        const cardSelectOptions = cardInfo[key]?.map(option => option?.value)?.join(",")
        cardData[key] = cardSelectOptions
      } else {
        cardData[key] = cardInfo[key].value
      }
    })
    Object.keys(checkInfo).forEach(key => {
      checkData[key] = checkInfo[key].value
    })
    Object.keys(achInfo).forEach(key => {
      achData[key] = achInfo[key].value
    })

    if (achData['emailAch'] && achData['emailAch'] !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(achData['emailAch'])) {
      toast.show({
        title: 'Warning',
        description: 'Please enter Email for payment notification as email format!'
      })
      return
    }

    if (supplierPrimaryCardEmail !== '') {
      setSupplierPrimaryCardEmail('')
    }

    if ((achInstructionFile && achInstructionFile.name) && (cardAuthorizationFormFile && cardAuthorizationFormFile.name)) {
      setIsLoadingInfo(true)
      dispatch(
        uploadAchInstruction(achInstructionFile, (event) => {
          setProgress(Math.round((100 * event.loaded) / event.total))
        })
      ).then((response) => {
        toast.show({
          title: 'Success',
          description: response.data.message,
        })

        achData.achInstructions = response.data.generatename

        dispatch(
          uploadCardAuthorizationFormFile(cardAuthorizationFormFile)
        ).then((res) => {
          toast.show({
            title: 'Success',
            description: res.data.message,
          })
          cardData.cardAuthorizationFormFile = res.data.generatename

          dispatch(
            createMasterFromChilds({
              childIds: isCreateNewLocationMaster ? [selectedKeys] : selectedKeys,
              basicData: basicData,
              cardData: cardData,
              paymentData: { ...checkData, ...achData },
              feeData: deliveryMethodsFeeValues,
              primaryMasterId: isCreateNewLocationMaster ? selectedSuppliers?.[0]?.baseInfo?.masterId : null,
              isFromList
            })
          ).then(async (result) => {
            await dispatchEmailsData(addCardEmailValues, result?.id)
            await addCreateMasterHistory(result?.id)
            let note = 'Child supplier assigned to Master ' + '<a target="_blank" href="/suppliers/' + result?.id + '"><b>' + result?.suppliername + '</b></a> by <b><em>' + user.firstname + ' ' + user.lastname + '</em></b>';
            if ((selectedKeys && !isFromList && !isFromRelatedSupplier && !listSupplier) || (selectedKeys && !isFromList && isFromRelatedSupplier && listSupplier)) {
              await addCreateMasterHistory(selectedKeys, note)
            }
            if ((isFromList || isFromRelatedSupplier) && (listSupplier || !isCreatingMasters)) {
              const ids = Array.isArray(listSupplier) ? listSupplier : listSupplier?.id
              await onUpdateListSupplier(ids, result?.id, 'Manually Created Master', listSupplier?.listId)
            } else if (isCreatingMasters) {
              var currentIndex = selectedChildSuppliers?.indexOf(selectedSuppliers?.[0]);
              const nextIndex = (currentIndex + 1) % selectedChildSuppliers?.length;
              if (nextIndex) {
                let selectedSupplier = selectedChildSuppliers?.find((sup) => sup?.id === selectedChildSuppliers?.[nextIndex]?.id)
                setSelectedSuppliers([selectedSupplier])
                await onUpdateListSupplier(selectedSuppliers?.[0]?.id, result?.id, 'Manually Created Master', selectedSuppliers?.[0]?.listId)
                setCurrentTab('basic')
                return
              } else {
                await onUpdateListSupplier(selectedSuppliers?.[0]?.id, result?.id, 'Manually Created Master', selectedSuppliers?.[0]?.listId)
                setSelectedSuppliers([])
              }
            }
            setIsLoadingInfo(false)
            onClose()
          }).catch(() => {
            setIsLoadingInfo(false)
          })
        }).catch(() => {
          setIsLoadingInfo(false)
        })
      }).catch(() => {
        toast.show({
          title: 'Warning',
          description: 'Could not upload the ach instructions and card authorization form files!',
        })
        setIsLoadingInfo(false)
      })
    } else if (achInstructionFile && achInstructionFile.name) {
      setIsLoadingInfo(true)
      dispatch(
        uploadAchInstruction(achInstructionFile, (event) => {
          setProgress(Math.round((100 * event.loaded) / event.total))
        })
      ).then((response) => {
        toast.show({
          title: 'Success',
          description: response.data.message,
        })

        achData.achInstructions = response.data.generatename
        dispatch(
          createMasterFromChilds({
            childIds: isCreateNewLocationMaster ? [selectedKeys] : selectedKeys,
            basicData: basicData,
            cardData: cardData,
            paymentData: { ...checkData, ...achData },
            feeData: deliveryMethodsFeeValues,
            primaryMasterId: isCreateNewLocationMaster ? selectedSuppliers?.[0]?.baseInfo?.masterId : null,
            isFromList
          })
        ).then(async (result) => {
          await dispatchEmailsData(addCardEmailValues, result?.id)
          await addCreateMasterHistory(result?.id)
          let note = 'Child supplier assigned to Master ' + '<a target="_blank" href="/suppliers/' + result?.id + '"><b>' + result?.suppliername + '</b></a> by <b><em>' + user.firstname + ' ' + user.lastname + '</em></b>';
          if ((selectedKeys && !isFromList && !isFromRelatedSupplier && !listSupplier) || (selectedKeys && !isFromList && isFromRelatedSupplier && listSupplier)) {
            await addCreateMasterHistory(selectedKeys, note)
          }
          if ((isFromList || isFromRelatedSupplier) && (listSupplier || !isCreatingMasters)) {
            const ids = Array.isArray(listSupplier) ? listSupplier : listSupplier?.id
            await onUpdateListSupplier(ids, result?.id, 'Manually Created Master', listSupplier?.listId)
          } else if (isCreatingMasters) {
            var currentIndex = selectedChildSuppliers?.indexOf(selectedSuppliers?.[0]);
            const nextIndex = (currentIndex + 1) % selectedChildSuppliers?.length;
            if (nextIndex) {
              let selectedSupplier = selectedChildSuppliers?.find((sup) => sup?.id === selectedChildSuppliers?.[nextIndex]?.id)
              setSelectedSuppliers([selectedSupplier])
              await onUpdateListSupplier(selectedSuppliers?.[0]?.id, result?.id, 'Manually Created Master', selectedSuppliers?.[0]?.listId)
              setCurrentTab('basic')
              return
            } else {
              await onUpdateListSupplier(selectedSuppliers?.[0]?.id, result?.id, 'Manually Created Master', selectedSuppliers?.[0]?.listId)
              setSelectedSuppliers([])
            }
          }
          setIsLoadingInfo(false)
          onClose()
        }).catch(() => {
          setIsLoadingInfo(false)
        })
      }).catch(() => {
        toast.show({
          title: 'Warning',
          description: 'Could not upload the ach instruction!',
        })
        setIsLoadingInfo(false)
      })
    } else if (cardAuthorizationFormFile && cardAuthorizationFormFile.name) {
      setIsLoadingInfo(true)
      dispatch(
        uploadCardAuthorizationFormFile(cardAuthorizationFormFile)
      ).then((response) => {
        toast.show({
          title: 'Success',
          description: response.data.message,
        })

        cardData.cardAuthorizationFormFile = response.data.generatename
        dispatch(
          createMasterFromChilds({
            childIds: isCreateNewLocationMaster ? [selectedKeys] : selectedKeys,
            basicData: basicData,
            cardData: cardData,
            paymentData: { ...checkData, ...achData },
            feeData: deliveryMethodsFeeValues,
            primaryMasterId: isCreateNewLocationMaster ? selectedSuppliers?.[0]?.baseInfo?.masterId : null,
            isFromList
          })
        ).then(async (result) => {
          await dispatchEmailsData(addCardEmailValues, result?.id)
          await addCreateMasterHistory(result?.id)
          let note = 'Child supplier assigned to Master ' + '<a target="_blank" href="/suppliers/' + result?.id + '"><b>' + result?.suppliername + '</b></a> by <b><em>' + user.firstname + ' ' + user.lastname + '</em></b>';
          if ((selectedKeys && !isFromList && !isFromRelatedSupplier && !listSupplier) || (selectedKeys && !isFromList && isFromRelatedSupplier && listSupplier)) {
            await addCreateMasterHistory(selectedKeys, note)
          }
          if ((isFromList || isFromRelatedSupplier) && (listSupplier || !isCreatingMasters)) {
            const ids = Array.isArray(listSupplier) ? listSupplier : listSupplier?.id
            await onUpdateListSupplier(ids, result?.id, 'Manually Created Master', listSupplier?.listId)
          } else if (isCreatingMasters) {
            var currentIndex = selectedChildSuppliers?.indexOf(selectedSuppliers?.[0]);
            const nextIndex = (currentIndex + 1) % selectedChildSuppliers?.length;
            if (nextIndex) {
              let selectedSupplier = selectedChildSuppliers?.find((sup) => sup?.id === selectedChildSuppliers?.[nextIndex]?.id)
              setSelectedSuppliers([selectedSupplier])
              await onUpdateListSupplier(selectedSuppliers?.[0]?.id, result?.id, 'Manually Created Master', selectedSuppliers?.[0]?.listId)
              setCurrentTab('basic')
              return
            } else {
              await onUpdateListSupplier(selectedSuppliers?.[0]?.id, result?.id, 'Manually Created Master', selectedSuppliers?.[0]?.listId)
              setSelectedSuppliers([])
            }
          }
          setIsLoadingInfo(false)
          onClose()
        })
      }).catch(() => {
        toast.show({
          title: 'Warning',
          description: 'Could not upload the card authorization form file!',
        })
        setIsLoadingInfo(false)
      })
    } else {
      setIsLoadingInfo(true)
      dispatch(
        createMasterFromChilds({
          childIds: isCreateNewLocationMaster ? [selectedKeys] : selectedKeys,
          basicData: basicData,
          cardData: cardData,
          paymentData: { ...checkData, ...achData },
          feeData: deliveryMethodsFeeValues,
          primaryMasterId: isCreateNewLocationMaster ? selectedSuppliers?.[0]?.baseInfo?.masterId : null,
          isFromList
        })
      ).then(async (result) => {
        await dispatchEmailsData(addCardEmailValues, result?.id)
        await addCreateMasterHistory(result?.id)
        let note = 'Child supplier assigned to Master ' + '<a target="_blank" href="/suppliers/' + result?.id + '"><b>' + result?.suppliername + '</b></a> by <b><em>' + user.firstname + ' ' + user.lastname + '</em></b>';
        if ((selectedKeys && !isFromList && !isFromRelatedSupplier && !listSupplier) || (selectedKeys && !isFromList && isFromRelatedSupplier && listSupplier)) {
          await addCreateMasterHistory(selectedKeys, note)
        }
        if ((isFromList || isFromRelatedSupplier) && (listSupplier || !isCreatingMasters)) {
          const ids = Array.isArray(listSupplier) ? listSupplier : listSupplier?.id
          await onUpdateListSupplier(ids, result?.id, 'Manually Created Master', listSupplier?.listId)
        } else if (isCreatingMasters) {
          var currentIndex = selectedChildSuppliers?.indexOf(selectedSuppliers?.[0]);
          const nextIndex = (currentIndex + 1) % selectedChildSuppliers?.length;
          if (nextIndex) {
            let selectedSupplier = selectedChildSuppliers?.find((sup) => sup?.id === selectedChildSuppliers?.[nextIndex]?.id)
            setSelectedSuppliers([selectedSupplier])
            await onUpdateListSupplier(selectedSuppliers?.[0]?.id, result?.id, 'Manually Created Master', selectedSuppliers?.[0]?.listId)
            setCurrentTab('basic')
            return
          } else {
            await onUpdateListSupplier(selectedSuppliers?.[0]?.id, result?.id, 'Manually Created Master', selectedSuppliers?.[0]?.listId)
            setSelectedSuppliers([])
          }
        }
        setIsLoadingInfo(false)
        onClose()
      }).catch(() => {
        setIsLoadingInfo(false)
        return
      })

      if (!isFromList && !isFromRelatedSupplier) {
        dispatch(getChildSuppliers({
          limit: 10,
          offset: 0,
          searchList: {},
          noMaster: false,
          hasMaster: false
        }))
        dispatch(getMasterSuppliers({
          limit: 10,
          offset: 0,
          searchList: {}
        }))
      }
    }
  }

  const dispatchEmailsData = async (addEmailValues, supplierId) => {
    if (Object.keys(addEmailValues).length > 0) {
      await dispatch(
        addCardAcceptanceEmails({
          supplierId: supplierId,
          userId: id,
          cardEmailsData: {
            addEmailValues
          },
        })
      )
    }
  }

  // to add Create Master Supplier changelog
  const addCreateMasterHistory = async (supplierId, note = '') => {
    var note = note === '' ? 'Supplier created by <b><em>' + user.firstname + ' ' + user.lastname + '</em></b>' : note;
    await dispatch(
      addSupplierHistory({
        supplierId: supplierId,
        note: note,
        noteType: 'changelog'
      })
    )
  }

  const handleChangeAchInstructionFile = (file) => {
    setAchInstructionFile(file)
  }

  const handleCloseEINExistModal = () => {
    setShowEINExistModal(false)
    setIsCheckBlurEINInput(false)
    setOnClickNext(false)
  }

  const handleNextTab = async () => {
    setCurrentTab(createSupplierTabs[(createSupplierTabs.findIndex(tab => tab.name === currentTab) + 1) % 4].name)
    setCurrentStep(createSupplierTabs.findIndex(tab => tab.name === currentTab) + 1)
    document.getElementById("main-content").scrollTop = 0
  }

  const handleBlurEmployerIdNumber = async () => {
    setIsCheckBlurEINInput(true)
    const isEINExists = await dispatch(checkEmployerIdNumberExists({
      employerIdNumber: basicInfo.employerIdNumber?.value,
      getEINData: true
    }))

    if (isEINExists?.einCount && isEINExists?.einCount > 0) {
      setShowEINExistModal(true)
      setSupplierExistWithEIN(isEINExists.einResult[0])
      return
    }
  }

  const handleClickTab = async () => {
    setOnClickNext(true)
    if (currentTab === 'ach') {
      if (isValidatingAchEmail) {
        toast.show({
          title: 'Warning',
          description: 'validating Ach acceptance email...!',
        })
        return
      }
      if (achInfo?.bankRoutingNumber?.value && achInfo.bankRoutingNumber.value !== '' && !/^\d{9}$/.test(achInfo.bankRoutingNumber?.value)) {
        toast.show({
          title: 'Warning',
          description: 'Bank Routing Number should be 9 digits!',
        })
        return
      }
      if (!isAchEmailValid && isAchEmailValid !== '') {
        toast.show({
          title: 'Warning',
          description: 'Please enter Email for payment notification as email format!'
        })
        return
      }

      if (achInfo?.isAchThroughPortal?.value && portalURLError) {
        toast.show({
          title: 'Warning',
          description: 'Invalid Portal URL!'
        })
        return
      }

      if (achInfo?.isAchThroughPortal?.value && !achInfo?.achPortalURL?.value) {
        toast.show({
          title: 'Warning',
          description: 'ACH Portal URL shouldn\'t be empty!'
        })
        return
      }
    }

    if (currentTab === 'check') {
      if (checkInfo?.checkAddress1?.value) {
        let address = convertAddress(checkInfo?.checkAddress1?.value)
        checkInfo.checkAddress1 = { label: address, value: address }
      }

      if (checkInfo?.checkZip?.value) {
        let validZip = checkZip(checkInfo?.checkZip?.value)
        if (!validZip) {
          toast.show({
            title: 'Warning',
            description: 'Invalid Zip',
          })
          return
        }
      }

      if (checkInfo?.checkState?.value && checkInfo?.checkState?.value !== '' && !/^[a-zA-Z\s]+$/.test(checkInfo?.checkState?.value)) {
        toast.show({
          title: 'Warning',
          description: 'State must include only characters!',
        })
        return
      }
      !isFromList && !isFromRelatedSupplier && handleClose()


      handleCreateMaster()
      // setShowCreateMasterModal(false)
      return
    }

    if (currentTab === 'basic') {
      if (basicInfo?.suppliername?.value === '' || !basicInfo?.suppliername?.value) {
        toast.show({
          title: 'Warning',
          description: 'Supplier Name shouldn\'t be empty!',
        })
        return
      }
      if (isValidatingBasicPhone) {
        toast.show({
          title: 'Warning',
          description: 'validating basic info phone number...!',
        })
        return
      }
      if (isValidatingBasicEmail) {
        toast.show({
          title: 'Warning',
          description: 'validating basic info email...!',
        })
        return
      }

      if (!isBasicEmailValid && isBasicEmailValid !== '') {
        toast.show({
          title: 'Warning',
          description: 'Invalid Email!'
        })
        return
      }

      if (isBasicPhoneValid === false) {
        toast.show({
          title: 'Warning',
          description: 'Invalid Phone Number!',
        })
        return
      }

      if (!isBasicFaxValid) {
        toast.show({
          title: 'Warning',
          description: 'Invalid Fax Number!',
        })
        return
      }

      if (!isNaicsValid) {
        toast.show({
          title: 'Warning',
          description: 'Invalid NAICS Code. Must be atleast 5 or 6 digits long!.'
        })
        return
      }

      if (!isSicValid) {
        toast.show({
          title: 'Warning',
          description: 'Invalid SIC Code. Must be atleast 4 digits long!.'
        })
        return
      }

      if (basicInfo.employerIdNumber?.value && basicInfo.employerIdNumber?.value !== '') {
        // check that EIN is different from child EIN
        // if (basicInfo.employerIdNumber?.value === childBasicInfo.employerIdNumber?.value) {
        //   toast.show({
        //     title: 'Warning',
        //     description: 'Please enter different Employer Id from Child!.'
        //   })
        //   return
        // }

        // check that EIN is entered in valid format or not
        if (basicInfo.employerIdNumber?.value !== '' && !/^(\d{2}-\d{7})?$/.test(basicInfo.employerIdNumber?.value)) {
          toast.show({
            title: 'Warning',
            description: 'Invalid Employee Id Number. Must be 9 digit number formatted xx-xxxxxxx.'
          })
          return
        }

        // check that if EIN already exists
        const isEINExists = await dispatch(checkEmployerIdNumberExists({
          employerIdNumber: basicInfo.employerIdNumber?.value,
          getEINData: true
        }))

        if (isEINExists?.einCount && isEINExists?.einCount > 0) {
          setShowEINExistModal(true)
          setSupplierExistWithEIN(isEINExists.einResult[0])
          return
        }
      }

      if (basicInfo?.abbreviatedState?.value && basicInfo?.abbreviatedState?.value !== '') {
        let regex = /^[a-zA-Z\s]{2}$/
        let stateChars = '2'
        if (basicInfo?.country?.value && (basicInfo?.country?.value.trim().toLowerCase() === 'australia' || basicInfo?.country.value.trim().toLowerCase() === 'aus')) {
          regex = /^[a-zA-Z\s]{2,3}$/
          stateChars = '2 or 3'
        }
        if (!regex.test(basicInfo?.abbreviatedState?.value.trim())) {
          toast.show({
            title: 'Warning',
            description: 'Invalid State. Must be ' + stateChars + ' characters long!'
          })
          return
        }

        basicInfo.state = { ...basicInfo.abbreviatedState }
      }

      if (basicInfo?.address1?.value) {
        let address = convertAddress(basicInfo?.address1?.value)
        basicInfo.address1 = { label: address, value: address }
      }

      if (basicInfo?.zip?.value) {
        let validZip = checkZip(basicInfo?.zip?.value)
        if (!validZip) {
          toast.show({
            title: 'Warning',
            description: 'Invalid Zip',
          })
          return
        }
      }

      document.getElementById("main-content").scrollTop = 0
    }

    if (currentTab === 'card') {
      if (isValidatingCardPhone || isValidatingIVRPhone) {
        toast.show({
          title: 'Warning',
          description: 'validating card acceptance phone number...!',
        })
        return
      }
      if (isValidatingCardEmail) {
        toast.show({
          title: 'Warning',
          description: 'validating card acceptance email...!',
        })
        return
      }

      if (isEmailValid === false) {
        toast.show({
          title: 'Warning',
          description: 'Invalid Email!'
        })
        return
      }

      if (supplierPrimaryCardEmail !== '') {
        var newIndex = Object.keys(addCardEmailValues).length > 0 ? (parseInt(Object.keys(addCardEmailValues)[Object.keys(addCardEmailValues).length - 1]) + 1) : Object.keys(addCardEmailValues).length
        addCardEmailValues[newIndex] = {
          'email': supplierPrimaryCardEmail?.email,
          'emailType': cardEmailType,
          emailContactId: supplierPrimaryCardEmail?.emailContactId
        }
        setSupplierPrimaryCardEmail('')
        var index = 'extra-email-name-' + (addedEmailValues.length + 1)
        addedEmailValues.push({ [index]: { 'email': supplierPrimaryCardEmail?.email, 'emailType': cardEmailType, emailContactId: supplierPrimaryCardEmail?.emailContactId } })
        handleOnAddedEmails(addedEmailValues)
      } else {
        if (cardInfo?.['isAcceptCardPaymentByEmail'].value && addedEmailValues.filter(x => x).length === 0) {
          toast.show({
            title: 'Danger',
            description: 'Cannot save email acceptance without a valid email!',
          })
          return
        }
      }

      var invalidEmail = false;
      var emptyEmailType = false;
      const hasDuplicateEmails = findDuplicateEmails(addCardEmailValues);
      if (Object.keys(addCardEmailValues).length > 0) {
        Object.keys(addCardEmailValues).map((key, index) => {
          if (addCardEmailValues[key] && addCardEmailValues[key]?.email !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(addCardEmailValues[key]?.email)) {
            invalidEmail = true
            delete addCardEmailValues[key]
            return
          }
          if (addCardEmailValues[key] && addCardEmailValues[key]?.emailType === '') {
            if (cardEmailType === '') {
              emptyEmailType = true
              return
            } else {
              addCardEmailValues[key]['emailType'] = cardEmailType
            }
          }
        })
      }

      if (invalidEmail) {
        toast.show({
          title: 'Warning',
          description: 'Email Address must be in email format!',
        })
        return
      }

      if (emptyEmailType) {
        toast.show({
          title: 'Warning',
          description: 'Please choose the Email Type from dropdown!'
        })
        return
      }

      if (hasDuplicateEmails?.isDuplicateEmail) {
        toast.show({
          title: 'Warning',
          description: 'Please add unique emails. You have added duplicate emails',
        })
        setAddCardEmailValues(hasDuplicateEmails?.addedEmails)
        return
      }
      if (isPhoneValid === false) {
        toast.show({
          title: 'Warning',
          description: 'Invalid Phone Number!',
        })
        return
      }
      if (!isFaxValid) {
        toast.show({
          title: 'Warning',
          description: 'Invalid Fax Number!',
        })
        return
      }
      if (!isThirdPartyPortalUrlValid) {
        toast.show({
          title: 'Warning',
          description: 'Invalid Third Party Portal URL!',
        })
        return
      }
      if (!isPortalUrlValid) {
        toast.show({
          title: 'Warning',
          description: 'Invalid Portal URL!',
        })
        return
      }
      if (isIVRPhoneValid === false) {
        toast.show({
          title: 'Warning',
          description: 'Invalid IVR Phone Number!',
        })
        return
      }

      if (cardInfo?.['isAcceptCardPaymentByFax'].value && !cardInfo?.['cardPaymentByFaxValue']?.value) {
        toast.show({
          title: 'Danger',
          description: 'Cannot save fax acceptance without a valid fax!',
        })
        return
      }
      if (cardInfo?.['isAcceptCardPaymentByPhone']?.value) {
        if ((!cardInfo?.['isAcceptPOTSPhone']?.value && !cardInfo?.['isAcceptIVRPhone']?.value) || (cardInfo?.['isAcceptPOTSPhone']?.value && (!cardInfo?.['cardPaymentByPhoneValue']?.value || cardPhoneCountryCode === cardInfo?.['cardPaymentByPhoneValue']?.value))) {
          toast.show({
            title: 'Danger',
            description: 'Cannot save phone acceptance without a valid phone!',
          })
          return
        }
        if (cardInfo?.['isAcceptIVRPhone']?.value && (!cardInfo?.['cardPaymentIVRPhone']?.value || ivrCountryCode === cardInfo?.['cardPaymentIVRPhone']?.value)) {
          toast.show({
            title: 'Danger',
            description: 'Cannot save IVR phone acceptance without a valid phone!',
          })
          return
        }
      }
      if (cardInfo?.['isAcceptCardPaymentByOnlinePortal']?.value && ((cardInfo?.['isAcceptPortal']?.value && !cardInfo?.['portalUrl']?.value) || (cardInfo?.['isAccept3rdPartyPortal']?.value && !cardInfo?.['thirdPartyPortalUrl']?.value))) {
        toast.show({
          title: 'Danger',
          description: 'Cannot save online acceptance without a valid website!',
        })
        return
      }

      if (cardInfo?.isAcceptAmexCardConditions?.value || cardInfo?.isAcceptVisaCardConditions?.value || cardInfo?.isAcceptMastercardCardConditions?.value) {
        const cardData = {}
        Object.keys(cardInfo).forEach(key => {
          if (multiSelectColumns.includes(key)) {
            const cardSelectOptions = cardInfo[key]?.map(option => option?.value)?.join(",")
            cardData[key] = cardSelectOptions
          } else {
            cardData[key] = cardInfo[key].value
          }
        })

        if (cardInfo?.isAcceptAmexCardConditions?.value) {
          const isAmexCardConditions = checkAmexCardConditonsAdded(cardData)
          if (!isAmexCardConditions) {
            toast.show({
              title: 'Warning',
              description: 'Please add Amex Card Conditions!',
            })
            return
          }
        }
        if (cardInfo?.isAcceptVisaCardConditions?.value) {
          const isVisaCardConditions = checkVisaCardConditonsAdded(cardData)
          if (!isVisaCardConditions) {
            toast.show({
              title: 'Warning',
              description: 'Please add Visa Card Conditions!',
            })
            return
          }
        }
        if (cardInfo?.isAcceptMastercardCardConditions?.value) {
          const isMasterCardConditions = checkMasterCardConditonsAdded(cardData)
          if (!isMasterCardConditions) {
            toast.show({
              title: 'Warning',
              description: 'Please add Master Card Conditions!',
            })
            return
          }
        }
      }
    }
    handleNextTab()
  }

  const handleChangeCardAuthorizationFormFile = (file) => {
    setCardAuthorizationFormFile(file)
  }

  const handleOnAddEmails = (emailValues) => {
    setAddCardEmailValues(emailValues)
  }

  const handleOnAddedEmails = (addedEmailValues) => {
    setAddedEmailValues(addedEmailValues)
    setcardEmailType('')
  }

  const handlePrimaryCardEmail = (primaryEmail, contactId = null, isValid=false) => {
    if (primaryEmail.length !== 0) {
      setSupplierPrimaryCardEmail({
        email: primaryEmail,
        emailContactId: contactId
      })
    } else {
      setSupplierPrimaryCardEmail('')
    }

    if (primaryEmail.length === 0) {
      setIsEmailValid(true)
    } else {
      isValid ? setIsEmailValid(true) :  setIsEmailValid(false)
    }
  }

  const handleChangeChildSupplier = (colName, item) => {
    setIsLoadingInfo(true)
    let tmpBasicInfo = {}
    let tmpCardInfo = {}
    let tmpChildCardInfo = {}
    var currentsupplier = selectedSuppliers.filter(supplier => supplier.suppliername === item?.value)
    createSupplierBasicColumns.forEach(column => {
      if (column.name === 'fax') {
        if (!selectedSuppliers?.[0]?.[column.name] || /^([+]?[\s0-9]{3,})?(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(selectedSuppliers?.[0]?.[column.name])) {
          setIsBasicFaxValid(true)
        } else {
          setIsBasicFaxValid(false)
        }
      }
      tmpBasicInfo = {
        ...tmpBasicInfo,
        [column.name]: {
          label: currentsupplier?.[0]?.[column.name] || '',
          value: currentsupplier?.[0]?.[column.name] || '',
        }
      }
    })

    createSupplierCardColumns.forEach(cardColumn => {
      if (cardColumn.name === 'ccProcessingTime') {
        tmpCardInfo = {
          ...tmpCardInfo,
          [cardColumn.name]: {
            label: cardColumn.defaultValue + ' Days',
            value: cardColumn.defaultValue
          }
        }
        tmpChildCardInfo = {
          ...tmpChildCardInfo,
          [cardColumn.name]: {
            label: currentsupplier?.[0]?.cardAcceptance?.[cardColumn.name],
            value: currentsupplier?.[0]?.cardAcceptance?.[cardColumn.name],
          }
        }
      } else if (cardColumn.name === 'cardDiscountType') {
        tmpCardInfo = {
          ...tmpCardInfo,
          [cardColumn.name]: {
            label: '%',
            value: cardColumn.defaultValue
          }
        }

        tmpChildCardInfo = {
          ...tmpChildCardInfo,
          [cardColumn.name]: {
            label: !currentsupplier?.[0]?.cardAcceptance?.[cardColumn.name] ? '%' : currentsupplier?.[0]?.cardAcceptance?.[cardColumn.name] === 'Percentage' ? '%' : '$',
            value: currentsupplier?.[0]?.cardAcceptance?.[cardColumn.name] || 'Percentage'
          }
        }
      } else {
        if (cardColumn.name === 'cardPaymentByPhoneValue') {
          setIsPhoneValid(true)
        }
        if (multiSelectColumns.includes(cardColumn.name)) {
          tmpCardInfo = {
            ...tmpCardInfo,
            [cardColumn.name]: cardColumn.defaultValue
          }
          let childSelectOptions = []
          const childSelectOptionsArray = currentsupplier?.[0]?.cardAcceptance?.[cardColumn.name] ? currentsupplier?.[0]?.cardAcceptance?.[cardColumn.name].split(',') : []
          childSelectOptionsArray.map((option) => {
            option = option.replace(/^\s+|\s+$/g, "");
            childSelectOptions.push({
              label: (option[0].toUpperCase() + option.slice(1)).replaceAll('-', ' '),
              value: option
            })
          })
          tmpChildCardInfo = {
            ...tmpChildCardInfo,
            [cardColumn.name]: childSelectOptions
          }
        } else {
          tmpCardInfo = {
            ...tmpCardInfo,
            [cardColumn.name]: {
              label: typeof cardColumn.defaultValue !== 'string' ? JSON?.stringify(cardColumn.defaultValue)[0].toUpperCase() + JSON?.stringify(cardColumn.defaultValue).substring(1) : cardColumn.defaultValue,
              value: cardColumn.defaultValue
            }
          }
          tmpChildCardInfo = {
            ...tmpChildCardInfo,
            [cardColumn.name]: {
              label: currentsupplier?.[0]?.cardAcceptance?.[cardColumn.name],
              value: currentsupplier?.[0]?.cardAcceptance?.[cardColumn.name],
            }
          }
        }
      }
    })

    let tmpAchInfo = {}
    let tmpChildAchInfo = {}
    createSupplierAchColumns.forEach(achColumn => {
      if (achColumn.name === 'emailAch') {
        setIsAchEmailValid(true)
      }
      tmpAchInfo = {
        ...tmpAchInfo,
        [achColumn.name]: {
          label: typeof achColumn.defaultValue !== 'string' ? JSON?.stringify(achColumn.defaultValue)[0].toUpperCase() + JSON?.stringify(achColumn.defaultValue).substring(1) : achColumn.defaultValue,
          value: achColumn.defaultValue
        }
      }
      tmpChildAchInfo = {
        ...tmpChildAchInfo,
        [achColumn.name]: {
          label: currentsupplier?.[0]?.payment?.[achColumn.name],
          value: currentsupplier?.[0]?.payment?.[achColumn.name],
        }
      }
    })

    let tmpCheckInfo = {}
    let tmpChildCheckInfo = {}
    createSupplierCheckColumns.forEach(checkColumn => {
      if (checkColumn.name === 'cashDiscountType') {
        tmpCheckInfo = {
          ...tmpCheckInfo,
          [checkColumn.name]: {
            label: '%',
            value: checkColumn?.defaultValue
          }
        }

        tmpChildCheckInfo = {
          ...tmpChildCheckInfo,
          [checkColumn.name]: {
            label: !currentsupplier?.[0]?.payment?.[checkColumn.name] ? '%' : currentsupplier?.[0]?.payment?.[checkColumn.name] === 'Percentage' ? '%' : '$',
            value: currentsupplier?.[0]?.payment?.[checkColumn.name] || 'Percentage'
          }
        }
      } else {
        tmpCheckInfo = {
          ...tmpCheckInfo,
          [checkColumn.name]: {
            label: typeof checkColumn.defaultValue !== 'string' ? JSON?.stringify(checkColumn.defaultValue)[0].toUpperCase() + JSON?.stringify(checkColumn.defaultValue).substring(1) : checkColumn.defaultValue,
            value: checkColumn.defaultValue
          }
        }
        tmpChildCheckInfo = {
          ...tmpChildCheckInfo,
          [checkColumn.name]: {
            label: currentsupplier?.[0]?.payment?.[checkColumn.name],
            value: currentsupplier?.[0]?.payment?.[checkColumn.name],
          }
        }
      }
    })

    // setBasicInfo({ ...tmpBasicInfo })
    // setChildBasicInfo({ ...tmpBasicInfo })
    setIsEmailValid(true)
    setCardInfo(tmpCardInfo)
    setChildCardInfo(tmpChildCardInfo)
    setAchInfo(tmpAchInfo)
    setChildAchInfo(tmpChildAchInfo)
    setCheckInfo(tmpCheckInfo)
    setChildCheckInfo(tmpChildCheckInfo)
    var phoneNumber = !currentsupplier?.[0]?.['phone'] ? '' : currentsupplier?.[0]?.['phone']?.match(/^\s*(?:\+?(\d{1,4})\s)?/gi)[0] !== '' ? currentsupplier?.[0]?.['phone'] : '1 ' + currentsupplier?.[0]?.['phone']
    handleBasicInfoPhoneNumberFocusOut(null, null, phoneNumber, true, tmpBasicInfo, tmpBasicInfo)
    handleBasicInfoEmailFocusOut(currentsupplier?.[0]?.['email'])
  }

  const handleBasicInfoPhoneNumberFocusOut = async (event, country, phoneValue, isUseEffect = false, tmpBasicInfo = {}, tmpChildBasicInfo = {}) => {
    var countryCode = country && country.dialCode
    var phoneValueWithCode = phoneValue
    var testPhone = phoneValue
    // .replace(/^\s*(?:\+?(\d{1,3})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
    if (testPhone !== '' && testPhone !== countryCode && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(testPhone)) {
      setIsBasicPhoneValid(false)
      toast.show({
        title: 'Warning',
        description: 'Please enter valid phone number!'
      })
      return
    }

    if ((event && event.type === 'blur' && event.relatedTarget !== null && event.relatedTarget.classList.value === 'selected-flag') || (countryCode === phoneValueWithCode.replace(/^\s*(?:\+)/, ''))) {
      return
    }
    if (phoneValue !== '') {
      setIsValidatingBasicPhone(true)
      phoneValue = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
      var phoneValidationResult = await checkIsPhoneNumberValid(phoneValue, phoneValueWithCode, dispatch)
      setIsBasicPhoneValid(phoneValidationResult?.isPhoneValid)
      setIsValidatingBasicPhone(phoneValidationResult?.isValidatingPhone)
    } else {
      setIsBasicPhoneValid(true)
    }
    if (isUseEffect) {
      tmpBasicInfo = {
        ...tmpBasicInfo,
        'phone': {
          label: phoneValidationResult?.phoneNumber || '',
          value: phoneValidationResult?.phoneNumber || ''
        }
      }
      tmpChildBasicInfo = {
        ...tmpChildBasicInfo,
        'phone': {
          label: phoneValidationResult?.phoneNumber || '',
          value: phoneValidationResult?.phoneNumber || ''
        }
      }
      setBasicInfo({ ...tmpBasicInfo })
      setChildBasicInfo({ ...tmpChildBasicInfo })
      setIsLoadingInfo(false)
    }
  }

  const handleBasicInfoEmailFocusOut = async (emailValue, isRetry = false) => {
    if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
      setIsBasicEmailValid(false);
      setIsEmailRisky(false);
      toast.show({
        title: 'Warning',
        description: 'Email Address must be in email format!'
      })
      return
    }
    if (emailValue && emailValue !== '') {
      setIsValidatingBasicEmail(true)
      var emailValidationResult = await checkIsEmailValid(emailValue, dispatch, isRetry)
      setIsBasicEmailValid(emailValidationResult?.isEmailValid)
      setIsValidatingBasicEmail(emailValidationResult?.isValidatingEmail)
      setIsEmailRisky(emailValidationResult?.isEmailRisky)
    } else {
      setIsBasicEmailValid(true)
    }
  }

  const handleCardPhoneNumberFocusOut = async (event, country, phoneValue, colName) => {
    var countryCode = country && country.dialCode
    var phoneValueWithCode = phoneValue
    var testPhone = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
    if (testPhone !== '' && testPhone !== countryCode && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(testPhone)) {
      colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(false) : setIsIVRPhoneValid(false)
      toast.show({
        title: 'Warning',
        description: 'Please enter valid phone number!'
      })
      return
    }

    if ((event && event.type === 'blur' && event.relatedTarget !== null && event.relatedTarget.classList.value === 'selected-flag') || (countryCode === phoneValueWithCode.replace(/^\s*(?:\+)/, ''))) {
      return
    }
    if (phoneValue !== '') {
      colName === 'cardPaymentByPhoneValue' ? setIsValidatingCardPhone(true) : setIsValidatingIVRPhone(true)
      phoneValue = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
      var phoneValidationResult = await checkIsPhoneNumberValid(phoneValue, phoneValueWithCode, dispatch)
      colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(phoneValidationResult?.isPhoneValid) : setIsIVRPhoneValid(phoneValidationResult?.isPhoneValid)
      colName === 'cardPaymentByPhoneValue' ? setIsValidatingCardPhone(phoneValidationResult?.isValidatingPhone) : setIsValidatingIVRPhone(phoneValidationResult?.isValidatingPhone)
    } else {
      colName === 'cardPaymentByPhoneValue' ? setIsPhoneValid(true) : setIsIVRPhoneValid(true)
    }
  }

  const handleCardEmailFocusOut = async (emailValue, isInitialCall = false, isRetry = false) => {
    var valid = true;
    if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
      setIsEmailValid(false)
      toast.show({
        title: 'Warning',
        description: 'Email Address must be in email format!'
      })
      return
    }
    if (emailValue && emailValue !== '') {
      setIsValidatingCardEmail(true)
      var emailValidationResult = await checkIsEmailValid(emailValue, dispatch, isRetry)
      valid = emailValidationResult?.isEmailValid
      setIsEmailValid(emailValidationResult?.isEmailValid)
      setIsValidatingCardEmail(emailValidationResult?.isValidatingEmail)
    } else {
      setIsEmailValid(true)
    }

    if (isInitialCall) {
      return { valid }
    }
  }

  const handleAchEmailFocusOut = async (emailValue, isInitialCall = false, isRetry = false) => {
    var valid = true;
    if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
      setIsAchEmailValid(false)
      toast.show({
        title: 'Warning',
        description: 'Email Address must be in email format!'
      })
      return
    }
    if (emailValue && emailValue !== '') {
      setIsValidatingAchEmail(true)
      var emailValidationResult = await checkIsEmailValid(emailValue, dispatch, isRetry)
      valid = emailValidationResult?.isEmailValid
      setIsAchEmailValid(emailValidationResult?.isEmailValid)
      setIsValidatingAchEmail(emailValidationResult?.isValidatingEmail)
    } else {
      setIsAchEmailValid(true)
    }

    if (isInitialCall) {
      return { valid }
    }
  }

  const handleUpdateCardFeeInfo = (colName, item, type, feeValueColumnName, feeValueType) => {
    var feeValue = ''
    if (type === 'showHideFee') {
      setCardFeeInfo({ ...cardFeeInfo, 'showHideFee': { ...cardFeeInfo?.showHideFee, [colName]: item } })
    } else {
      if (item?.value !== '$' && item?.value !== '%') {
        var temp = "";
        temp = parseInt(item.replace(/\D/g, ''));
        item = temp ? ((temp) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
        if (feeValueType === '$') {
          if (! /^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/.test(item)) {
            item = item?.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? item.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
          }
        } else {
          if (! /^\d{0,2}(\.\d{0,2})?$/.test(item)) {
            item = item?.match(/^\d{0,2}(\.\d{0,2})?/gi) ? item.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
          }
        }
        setCardFeeInfo({ ...cardFeeInfo, 'feeValues': { ...cardFeeInfo?.feeValues, [colName]: item } })
      } else {
        feeValue = item?.value === '%' ? cardInfo?.[feeValueColumnName]?.value && cardInfo?.[feeValueColumnName]?.value?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ?
          parseInt(cardInfo?.[feeValueColumnName]?.value.replace(',', '').match(/^\d{0,2}(\.\d{0,2})?/gi)[0]).toFixed(2)
          : ''
          : cardInfo?.[feeValueColumnName]?.value

        setCardInfo({
          ...cardInfo,
          [feeValueColumnName]: {
            value: feeValue,
            label: feeValue
          },
          [colName]: item
        })
      }
    }
  }

  const status = progress === 100 ? 'success' : null
  const color = progress === 100 ? '#52c41a' : '#3385ff'
  // const isLoading = isCreatingMaster ? true : false

  const onUpdateDeliveryMethodsFeeValues = (feeInfo) => {
    setDeliveryMethodsFeeValues(feeInfo)
    setCardFeeInfo(defaultCardFeeInfo)
    setCardInfo({
      ...cardInfo,
      'americanExpressMinPaymnet': '',
      'americanExpressMaxPayment': '',
      'visaMinPayment': '',
      'visaMaxPayment': '',
      'mastercardMinPayment': '',
      'mastercardMaxPayment': '',
      'discoverMinPayment': '',
      'discoverMinPayment': '',
    })
  }

  // to set same card acceptance values in case of genric fee structure
  const handleChangeGenericFeeInfo = (colname, value, cardColumnsArray, feeValueColumnName, cardFeeColumnsArray, type = null, colname2 = '') => {
    if (type === 'accPerCard') {
      const amexCardFeeInfo = [
        { name: 'showAmexMinFee', value: false },
        { name: 'showAmexMaxFee', value: false },
        { name: 'showAmexIncrementalFee', value: false },
        { name: 'showAmexSecondProcessingFee', value: false }
      ]

      const visaCardFeeInfo = [
        { name: 'showVisaMinFee', value: false },
        { name: 'showVisaMaxFee', value: false },
        { name: 'showVisaIncrementalFee', value: false },
        { name: 'showVisaSecondProcessingFee', value: false }
      ]

      const masterCardFeeInfo = [
        { name: 'showMasterMinFee', value: false },
        { name: 'showMasterMaxFee', value: false },
        { name: 'showMasterIncrementalFee', value: false },
        { name: 'showMasterSecondProcessingFee', value: false }
      ]
      setShowAcceptancePerCard(value)
      value ?
        setAccPerCardText('Generic Fee Structure')
        :
        setAccPerCardText('Acceptance Per Card')
      setCardInfo({
        ...cardInfo,
        [colname]: {
          label: value,
          value: value
        }
      })
      setCardFeeInfo({
        ...cardFeeInfo,
        'showHideFee': {
          ...cardFeeInfo?.showHideFee,
          showAmexMinFee: cardInfo?.['amexMinPaymentFeeValue']?.value ? true : false,
          showAmexMaxFee: cardInfo?.['amexMaxPaymentFeeValue']?.value ? true : false,
          showAmexIncrementalFee: (cardInfo?.['amexIncrementalFeeValue']?.value || cardInfo?.['amexIncrementalPaymentAmount']?.value) ? true : false,
          showVisaMinFee: cardInfo?.['visaMinPaymentFeeValue']?.value ? true : false,
          showVisaMaxFee: cardInfo?.['visaMaxPaymentFeeValue']?.value ? true : false,
          showVisaIncrementalFee: (cardInfo?.['visaIncrementalFeeValue']?.value || cardInfo?.['visaIncrementalPaymentAmount']?.value) ? true : false,
          showMasterMinFee: cardInfo?.['mastercardMinPaymentFeeValue']?.value ? true : false,
          showMasterMaxFee: cardInfo?.['mastercardMaxPaymentFeeValue']?.value ? true : false,
          showMasterIncrementalFee: (cardInfo?.['mastercardIncrementalFeeValue']?.value || cardInfo?.['mastercardIncrementalPaymentAmount']?.value) ? true : false,
          showDiscoverMinFee: cardInfo?.['discoverMinPaymentFeeValue']?.value ? true : false,
          showDiscoverMaxFee: cardInfo?.['discoverMaxPaymentFeeValue']?.value ? true : false,
          showDiscoverIncrementalFee: (cardInfo?.['discoverIncrementalFeeValue']?.value || cardInfo?.['discoverIncrementalPaymentAmount']?.value) ? true : false,
          showAmexSecondProcessingFee: cardInfo?.amexSecondProcessingFeeValue?.value ? true : false,
          showVisaSecondProcessingFee: cardInfo?.visaSecondProcessingFeeValue?.value ? true : false,
          showMasterSecondProcessingFee: cardInfo?.mastercardSecondProcessingFeeValue?.value ? true : false,
          showDiscoverSecondProcessingFee: cardInfo?.discoverSecondProcessingFeeValue?.value ? true : false,
        }
      })
      return
    }

    let tmpCardInfo = { ...cardInfo }
    var feeValue = ''
    if (type === 'currency' || type === 'percent') {
      var temp = "";
      temp = value ? parseInt(value.replace(/\D/g, '')) : '';
      value = temp ? ((temp) / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '';
      if (type === 'currency') {
        if (/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/.test(value)) {
          value = value
        } else {
          value = value.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi) ? value.match(/^(\d+)((\,)(\d+))*((\,))*(\.\d{0,2})?$/gi)[0] : ''
        }
      }
      if (type === 'percent') {
        if (/^\d{0,2}(\.\d{0,2})?$/.test(value)) {
          value = value
        } else {
          value = value.match(/^\d{0,2}(\.\d{0,2})?/gi) ? value.match(/^\d{0,2}(\.\d{0,2})?/gi)[0] : ''
        }
      }
    }

    if (value === '$' || value === '%') {
      feeValue = value === '%' ? genericFeeValues?.[feeValueColumnName] && genericFeeValues?.[feeValueColumnName]?.toString().match(/^\d{0,2}(\.\d{0,2})?/gi) ?
        parseInt(genericFeeValues?.[feeValueColumnName].replace(',', '').match(/^\d{0,2}(\.\d{0,2})?/gi)[0]).toFixed(2)
        : ''
        : genericFeeValues?.[feeValueColumnName]

      setGenericFeeValues({
        ...genericFeeValues,
        [colname]: value,
        [feeValueColumnName]: feeValue
      })

      cardFeeColumnsArray.map((cardFeeColumn) => {
        tmpCardInfo = {
          ...tmpCardInfo,
          [cardFeeColumn]: {
            label: feeValue,
            value: feeValue
          }
        }
      })
    } else {
      if (colname2 !== '') {
        setGenericFeeValues({
          ...genericFeeValues,
          [colname]: value,
          [colname2]: false
        })
      } else {
        let tmpGenericFeeValues = { ...genericFeeValues }
        tmpGenericFeeValues[colname] = value
        if (colname === 'showCardConditions' && !value) {
          genericConditionColumns.forEach(column => {
            tmpGenericFeeValues = {
              ...tmpGenericFeeValues,
              [column.name]: column.value
            }
          })
        }
        setGenericFeeValues(tmpGenericFeeValues)
      }
      if (type === 'showHideFee') {
        return
      }
    }

    cardColumnsArray.map((cardColumn) => {
      tmpCardInfo = {
        ...tmpCardInfo,
        [cardColumn]: {
          label: value,
          value: value
        }
      }
    })

    if (colname === 'showCardConditions' && !value) {
      cardConditionColumns.forEach(column => {
        tmpCardInfo[column.name].value = column.value
      })
    }
    setCardInfo(tmpCardInfo)
  }

  const onPreviousHandler = () => {
    setShowEINExistModal(false)
    setCurrentTab(createSupplierTabs[(createSupplierTabs.findIndex(tab => tab.name === currentTab) - 1) % 4].name)
    setCurrentStep(createSupplierTabs.findIndex(tab => tab.name === currentTab) - 1);
    document.getElementById("main-content").scrollTop = 0
  }

  const handleCardConditionsChange = (colName, value) => {
    const amexColumns = [
      { name: 'amexProcessingFeeType', value: '$' },
      { name: 'amexProcessingFeeValue', value: '' },
      { name: 'amexSecondProcessingFeeType', value: '$' },
      { name: 'amexSecondProcessingFeeValue', value: '' },
      { name: 'amexMinPaymentFeeType', value: '$' },
      { name: 'amexMinPaymentFeeValue', value: '' },
      { name: 'amexMaxPaymentFeeType', value: '$' },
      { name: 'amexMaxPaymentFeeValue', value: '' },
      { name: 'amexIncrementalFeeType', value: '$' },
      { name: 'amexIncrementalFeeValue', value: '' },
      { name: 'americanExpressMinPaymnet', value: '' },
      { name: 'americanExpressMaxPayment', value: '' },
      { name: 'amexIncrementalPaymentAmount', value: '' },
      { name: 'isAcceptAmexVariableFee', value: null }
    ]

    const visaColumns = [
      { name: 'visaProcessingFeeType', value: '$' },
      { name: 'visaProcessingFeeValue', value: '' },
      { name: 'visaSecondProcessingFeeType', value: '$' },
      { name: 'visaSecondProcessingFeeValue', value: '' },
      { name: 'visaMinPaymentFeeType', value: '$' },
      { name: 'visaMinPaymentFeeValue', value: '' },
      { name: 'visaMaxPaymentFeeType', value: '$' },
      { name: 'visaMaxPaymentFeeValue', value: '' },
      { name: 'visaIncrementalFeeType', value: '$' },
      { name: 'visaIncrementalFeeValue', value: '' },
      { name: 'visaMinPayment', value: '' },
      { name: 'visaMaxPayment', value: '' },
      { name: 'visaIncrementalPaymentAmount', value: '' },
      { name: 'isAcceptVisaVariableFee', value: null }
    ]

    const masterColumns = [
      { name: 'mastercardProcessingFeeType', value: '$' },
      { name: 'mastercardProcessingFeeValue', value: '' },
      { name: 'mastercardSecondProcessingFeeType', value: '$' },
      { name: 'mastercardSecondProcessingFeeValue', value: '' },
      { name: 'mastercardMinPaymentFeeType', value: '$' },
      { name: 'mastercardMinPaymentFeeValue', value: '' },
      { name: 'mastercardMaxPaymentFeeType', value: '$' },
      { name: 'mastercardMaxPaymentFeeValue', value: '' },
      { name: 'mastercardIncrementalFeeType', value: '$' },
      { name: 'mastercardIncrementalFeeValue', value: '' },
      { name: 'mastercardMinPayment', value: '' },
      { name: 'mastercardMaxPayment', value: '' },
      { name: 'mastercardIncrementalPaymentAmount', value: '' },
      { name: 'isAcceptMasterCardVariableFee', value: null }
    ]

    const amexCardFeeInfo = [
      { name: 'showAmexMinFee', value: false },
      { name: 'showAmexMaxFee', value: false },
      { name: 'showAmexIncrementalFee', value: false },
      { name: 'showAmexSecondProcessingFee', value: false }
    ]

    const visaCardFeeInfo = [
      { name: 'showVisaMinFee', value: false },
      { name: 'showVisaMaxFee', value: false },
      { name: 'showVisaIncrementalFee', value: false },
      { name: 'showVisaSecondProcessingFee', value: false }
    ]

    const masterCardFeeInfo = [
      { name: 'showMasterMinFee', value: false },
      { name: 'showMasterMaxFee', value: false },
      { name: 'showMasterIncrementalFee', value: false },
      { name: 'showMasterSecondProcessingFee', value: false }
    ]

    if (value?.value) {
      setCardInfo({
        ...cardInfo,
        [colName]: value
      })
    } else {
      var columns = amexColumns
      var cardFeeCols = amexCardFeeInfo
      if (colName === 'isAcceptVisaCardConditions') {
        columns = visaColumns
        cardFeeCols = visaCardFeeInfo
      }
      if (colName === 'isAcceptMastercardCardConditions') {
        columns = masterColumns
        cardFeeCols = masterCardFeeInfo
      }
      const tmpCardInfo = { ...cardInfo }
      const tmpCardFeeInfo = { ...cardFeeInfo }

      columns.forEach(column => {
        tmpCardInfo[column.name].value = column.value
      })

      cardFeeCols.forEach(column => {
        tmpCardFeeInfo.showHideFee[column.name] = column.value
      })

      tmpCardInfo[colName] = value
      setCardInfo(tmpCardInfo)
      setCardFeeInfo(tmpCardFeeInfo)
    }
  }

  const handleAssignMaster = async (masterId = null) => {
    if ((isFromList && listSupplier) || isCreatingMasters) {
      setIsAssigningToExistingMaster(true)
      if (isCreatingMasters) {
        var currentIndex = selectedChildSuppliers?.indexOf(selectedSuppliers?.[0]);
        const nextIndex = (currentIndex + 1) % selectedChildSuppliers?.length;
        if (nextIndex) {
          let selectedSupplier = selectedChildSuppliers?.find((sup) => sup?.id === selectedChildSuppliers?.[nextIndex]?.id)
          setSelectedSuppliers([selectedSupplier])
          await onUpdateListSupplier(selectedSuppliers?.[0]?.id, masterId, 'Manually Matched Master', selectedSuppliers?.[0]?.listId)
          setCurrentTab('basic')
          setIsAssigningToExistingMaster(false)
          return
        } else {
          await onUpdateListSupplier(selectedSuppliers?.[0]?.id, masterId, 'Manually Matched Master', selectedSuppliers?.[0]?.listId)
          setSelectedSuppliers([])
        }
      } else {
        await onUpdateListSupplier(listSupplier?.id, masterId, 'Manually Matched Master', listSupplier?.listId)
      }
      setIsAssigningToExistingMaster(false)
      onClose()
    } else if (masterId && selectedKeys?.length) {
      setIsAssigningToExistingMaster(true)
      dispatch(
        assignMaster(selectedKeys, masterId)
      ).then((response) => {
        setIsAssigningToExistingMaster(false)
        onClose()
      }).catch(err => {
        setIsAssigningToExistingMaster(false)
        console.error('err', err);
      })
    }
  }

  return (
    <div className='create-master-modal pe-0 ps-0'>
      <div className='sticky-header bg-white position-sticky top-0'>
        <label className='child-supplier-name ps-4 pe-4'> {childBasicInfo?.suppliername?.value} </label>
        <div className="header ps-4 pe-4">
          <Steps current={currentStep}>
            {
              createSupplierTabs.map((tab, index) => (
                <Steps.Item key={tab.name} title={tab.label} description={`Step ${index + 1}`} />
              ))
            }
          </Steps>
        </div>
        <div className='new-master-supplier-tabs-header pt-3 p-4'>
          <div className="tab-header flex">
            <div className='first-child'></div>
            {(((isFromList || isFromRelatedSupplier) && currentTab === 'basic') || ((!isFromList && !isFromRelatedSupplier) || isCreatingMasters)) && (<label className='text-blue'> Child Supplier </label>)}
            <label className='text-blue'> {isCreateNewLocationMaster ? 'Location-Based Master Supplier' : 'Master Supplier'} </label>
          </div>
          <div className='tab-content flex'>
            <div className='first-child'></div>
            <div>
              {
                ((!isCreateNewLocationMaster && !isFromList && !isFromRelatedSupplier)) && // || (isFromList && !listSupplier)
                <Select
                  className='h4 mb-0 text-black'
                  onChange={(newValue) => handleChangeChildSupplier('suppliername', newValue)}
                  value={childBasicInfo['suppliername']}
                  options={
                    selectedSuppliers?.filter((supplier, index, self) => supplier['suppliername'] && self.findIndex(item => item['suppliername'] === supplier['suppliername']) === index)?.map(supplier => (
                      {
                        label: supplier['suppliername'] || '',
                        value: supplier['suppliername'] || '',
                      }
                    ))
                  }
                />
              }
            </div>
            <div></div>
          </div>
        </div>
      </div>
      <div className={`content ps-4 pe-4${(isLoadingInfo) ? ' position-relative loading' : ''}`}>
        {(isLoadingInfo) && <LoaderComponent />}
        {achInstructionFile && progress > 0 && (
          <Progress.Line percent={progress} strokeColor={color} status={status} />
        )}
        {
          currentTab === 'basic' && (
            <CreateMasterBasicTab
              columns={createSupplierBasicColumns}
              selectedSuppliers={selectedSuppliers}
              basicInfo={basicInfo}
              onChangeBasicInfo={handleUpdateBasicInfo}
              childBasicInfo={childBasicInfo}
              isPhoneValid={isBasicPhoneValid}
              isValidatingPhone={isValidatingBasicPhone}
              handleBasicInfoPhoneNumberFocusOut={handleBasicInfoPhoneNumberFocusOut}
              handleBasicInfoEmailFocusOut={handleBasicInfoEmailFocusOut}
              isEmailValid={isBasicEmailValid}
              isEmailRisky={isEmailRisky}
              isValidatingEmail={isValidatingBasicEmail}
              countryCode={basicPhoneCountryCode}
              supplierExistWithEIN={supplierExistWithEIN}
              showEINExistModal={showEINExistModal}
              handleClickTab={handleClickTab}
              handleCloseEINExistModal={handleCloseEINExistModal}
              handleNextTab={handleNextTab}
              handleBlurEmployerIdNumber={handleBlurEmployerIdNumber}
              isCheckBlurEINInput={isCheckBlurEINInput}
              onClickNext={onClickNext}
              onAssignMaster={handleAssignMaster}
              setAllContacts={setAllContacts}
              allContacts={allContacts}
              isLoadingInfo={isLoadingInfo}
            />
          )
        }
        {
          currentTab === 'card' && (
            <CreateMasterCardTab
              columns={createSupplierCardColumns}
              cardInfo={cardInfo}
              selectedSuppliers={selectedSuppliers}
              onChangeCardInfo={handleUpdateCardInfo}
              onChangeCardAuthorizationFormFile={handleChangeCardAuthorizationFormFile}
              cardAuthorizationFormFile={cardAuthorizationFormFile}
              onAddEmails={handleOnAddEmails}
              onPrimaryCardEmail={handlePrimaryCardEmail}
              supplierPrimaryCardEmail={supplierPrimaryCardEmail}
              addedEmailValues={addedEmailValues}
              onAddedEmails={handleOnAddedEmails}
              childCardInfo={childCardInfo}
              cardEmailType={cardEmailType}
              isPhoneValid={isPhoneValid}
              isValidatingPhone={isValidatingCardPhone}
              isIVRPhoneValid={isIVRPhoneValid}
              isValidatingIVRPhone={isValidatingIVRPhone}
              handleCardPhoneNumberFocusOut={handleCardPhoneNumberFocusOut}
              handleCardEmailFocusOut={handleCardEmailFocusOut}
              isEmailValid={isEmailValid}
              isValidatingEmail={isValidatingCardEmail}
              cardFeeInfo={cardFeeInfo}
              onUpdateCardFeeInfo={handleUpdateCardFeeInfo}
              onUpdateDeliveryMethodsFeeValues={onUpdateDeliveryMethodsFeeValues}
              deliveryMethodsFeeValues={deliveryMethodsFeeValues}
              countryCode={cardPhoneCountryCode}
              showAcceptancePerCard={showAcceptancePerCard}
              accPerCardText={accPerCardText}
              genericFeeValues={genericFeeValues}
              onChangeGenericFeeInfo={handleChangeGenericFeeInfo}
              isFromList={((isFromList || isFromRelatedSupplier) && listSupplier) ? true : false}
              onCardConditionsChange={handleCardConditionsChange}
              setAllContacts={setAllContacts}
              allContacts={allContacts}
            />
          )
        }
        {
          currentTab === 'ach' && (
            <CreateMasterAchTab
              columns={createSupplierAchColumns}
              selectedSuppliers={selectedSuppliers}
              achInfo={achInfo}
              achInstructionFile={achInstructionFile}
              onChangeAchInfo={handleUpdateAchInfo}
              onChangeAchInstructionFile={handleChangeAchInstructionFile}
              childAchInfo={childAchInfo}
              handleAchEmailFocusOut={handleAchEmailFocusOut}
              isEmailValid={isAchEmailValid}
              isValidatingEmail={isValidatingAchEmail}
              isFromList={((isFromList || isFromRelatedSupplier) && listSupplier) ? true : false}
              setAllContacts={setAllContacts}
              allContacts={allContacts}
            />
          )
        }
        {
          currentTab === 'check' && (
            <div className={`position-relative ${isCreatingMasterFromList ? 'loading' : ''}`}>
              {isCreatingMasterFromList && <LoaderComponent />}
              <CreateMasterCheckTab
                columns={createSupplierCheckColumns}
                selectedSuppliers={selectedSuppliers}
                checkInfo={checkInfo}
                onChangeCheckInfo={handleUpdateCheckInfo}
                childCheckInfo={childCheckInfo}
                isFromList={((isFromList || isFromRelatedSupplier) && listSupplier) ? true : false}
              />
            </div>
          )
        }
      </div>
      <div className="action-container justify-end ps-4 pe-4 position-sticky bottom-0">
        {
          createSupplierTabs.findIndex(tab => tab.name === currentTab) !== 0 && (
            <button
              type="button"
              disabled={isLoadingInfo}
              className="btn btn-prev"
              onClick={onPreviousHandler}>
              Prev
            </button>
          )
        }
        {
          createSupplierTabs.findIndex(tab => tab.name === currentTab) === createSupplierTabs.length - 1 ? (
            <button type="button" disabled={isLoadingInfo} className="btn btn-create" onClick={handleClickTab}>
              Create
            </button>
          ) : (
            ((isValidatingBasicPhone || isValidatingCardPhone || isValidatingCardEmail || isValidatingBasicEmail || isValidatingAchEmail || isValidatingIVRPhone) ? (
              <button type="button" className="btn btn-next">
                Validating...
              </button>
            ) : (
              <button type="button" disabled={isLoadingInfo} className="btn btn-next" onClick={handleClickTab}>
                Next
              </button>
            ))
          )
        }
      </div>
    </div>
  )
}
export default CreateMasterModal